(function () {
  'use strict';

  /* ============================================================
     TERRAIN — Smart Seeding App Engine
     Core: weather API, agronomic rules, UI state machine,
           forecast strip, caching, bilingual strings.
     ============================================================ */

  /* --- Language detection --- */
  var LANG = (window.Shopify && window.Shopify.locale ? window.Shopify.locale : (navigator.language || navigator.languages && navigator.languages[0] || 'fr')).startsWith('en') ? 'en' : 'fr';

  /* --- Bilingual UI strings --- */
  var UI = {
    headline:           { fr: 'Quand semer votre mélange?', en: 'When should you seed your mix?' },
    blend_label:        { fr: 'Sélectionnez votre mélange :', en: 'Select your blend:' },
    postal_placeholder: { fr: 'ex. J0E 2P0', en: 'e.g. J0E 2P0' },
    postal_label:       { fr: 'Votre code postal', en: 'Your postal code' },
    postal_hint:        { fr: 'On l\'utilise pour les conditions météo et la température du sol près de chez vous. On ne le partage jamais.', en: 'Used to fetch local weather and soil conditions where you live. We never share it.' },
    site_label:         { fr: 'Où semez-vous? (optionnel)', en: 'Where are you seeding? (optional)' },
    site_hint:          { fr: 'Ex. : devant la maison, cour arrière, jardin du fond. On l\'utilisera pour personnaliser votre résultat.', en: 'E.g. front yard, back yard, far garden. We\'ll use it to personalize your result.' },
    site_placeholder:   { fr: 'ex. devant la maison', en: 'e.g. front yard' },
    context_label:      { fr: 'Votre recommandation pour', en: 'Your recommendation for' },
    cta:                { fr: 'Obtenir ma recommandation', en: 'Get my recommendation' },
    loading:            { fr: 'Analyse des conditions météo...', en: 'Analyzing weather conditions...' },
    loading_steps:      {
      fr: ['Connexion à la station météo locale...', 'Évaluation de la température du sol...', 'Vérification du risque de gel...', 'Analyse de votre fenêtre de semis...', 'Préparation de votre recommandation...'],
      en: ['Connecting to your local weather station...', 'Estimating soil temperature...', 'Checking frost risk...', 'Analyzing your seeding window...', 'Preparing your recommendation...']
    },
    forecast_label:     { fr: 'Prévisions {N} jours', en: '{N}-day forecast' },
    modify:             { fr: 'Modifier', en: 'Change' },
    login_prompt:       { fr: 'Connectez-vous pour retrouver votre code postal automatiquement.', en: 'Sign in to get your postal code automatically.' },
    login_link:         { fr: 'Se connecter', en: 'Sign in' },
    status_go:          { fr: 'Semez maintenant', en: 'Seed now' },
    status_caution:     { fr: 'Attendez si possible', en: 'Wait if possible' },
    status_wait:        { fr: 'Pas encore', en: 'Not yet' },
    product_link:       { fr: 'Voir les détails du mélange', en: 'See blend details' },
    seeding_cta:        { fr: 'J\'ai semé aujourd\'hui — suivre ma germination', en: 'I seeded today — track my germination' },
    error_format:       { fr: 'Format non reconnu. Entrez un code postal canadien — ex. J0E 2P0', en: 'Invalid format. Enter a Canadian postal code — e.g. J0E 2P0' },
    error_not_qc:       { fr: 'Ce code postal semble être hors du Québec. Le conseiller TERRAIN est conçu pour les conditions du Québec.', en: 'This postal code appears to be outside Quebec. The TERRAIN advisor is designed for Quebec conditions.' },
    error_api:          { fr: 'Impossible de récupérer les prévisions. Vérifiez votre connexion et réessayez.', en: 'Unable to fetch forecast. Check your connection and try again.' },
    error_retry:        { fr: 'Réessayer', en: 'Try again' },
    cache_notice:       { fr: 'Prévisions mises à jour il y a', en: 'Forecast updated' },
    cache_refresh:      { fr: 'actualiser', en: 'refresh' },
    cache_hours:        { fr: 'h', en: 'h ago' },
    fallback_notice:    { fr: 'Prévisions météo non disponibles. Cette recommandation est basée sur la saison — vérifiez à nouveau lorsque vous avez du signal pour une réponse précise.', en: 'Weather data unavailable. This recommendation is based on the season — check again when you have signal for a precise answer.' },
    window_today:       { fr: 'Conditions idéales aujourd\'hui et pour les {X} prochains jours.', en: 'Ideal conditions today and for the next {X} days.' },
    window_future:      { fr: 'Meilleures conditions à partir du {DATE} — dans {X} jours.', en: 'Better conditions starting {DATE} — in {X} days.' },
    window_none:        { fr: 'Conditions non idéales pour les prochains jours. Revenez vérifier bientôt.', en: 'Conditions not ideal for the coming days. Check back soon.' },
    greeting:           { fr: 'Bonjour, {NAME}', en: 'Hello, {NAME}' },
    capture_headline:   { fr: 'Recevez votre rappel de semis et le suivi de germination par courriel.', en: 'Get your seeding reminder and germination tracking by email.' },
    capture_subline:    { fr: 'Entrez votre courriel — c\'est tout. Pas de compte requis.', en: 'Enter your email — that\'s it. No account required.' },
    capture_submit:     { fr: 'Me tenir au courant', en: 'Keep me posted' },
    capture_account:    { fr: 'Créer un compte pour garder votre historique de semis →', en: 'Create an account to keep your seeding history →' },
    calc_label:         { fr: 'Calculer la quantité nécessaire', en: 'Calculate the amount you need' },
    day_names:          { fr: ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'], en: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'] },
    quick_buy_label:    { fr: 'Combien vous faut-il?', en: 'How much do you need?' },
    quick_buy_label_wait: { fr: 'Commandez maintenant — semez quand le moment sera idéal.', en: 'Order now — seed when conditions are right.' },
    quick_buy_atc:      { fr: 'Ajouter au panier — {PRICE}', en: 'Add to cart — {PRICE}' },
    quick_buy_added:    { fr: '✓ Ajouté au panier', en: '✓ Added to cart' },
    quick_buy_error:    { fr: 'Erreur — réessayez', en: 'Error — try again' },
    quick_buy_note:     { fr: 'Livraison gratuite dans les Cantons-de-l\'Est', en: 'Free delivery in the Eastern Townships' },
    quick_buy_pdp:      { fr: 'Voir tous les détails →', en: 'See all details →' },
    next_steps_heading: { fr: 'Et après?', en: 'What\'s next?' },
    next_collection:    { fr: 'Voir tous les mélanges TERRAIN', en: 'See all TERRAIN blends' },
    next_copy_link:     { fr: 'Copier le lien de ce résultat', en: 'Copy link to this result' },
    next_copy_done:     { fr: 'Lien copié ✓', en: 'Link copied ✓' },
    fast_track_text:    { fr: 'Vous avez semé {BLEND} le {DATE}.', en: 'You seeded {BLEND} on {DATE}.' },
    fast_track_btn:     { fr: 'Voir mon suivi de germination', en: 'See my germination tracker' },
    fast_track_dismiss: { fr: 'Nouveau semis ↓', en: 'New seeding ↓' },
    factors_toggle:     { fr: 'Pourquoi?', en: 'Why?' },
    factor_soil_temp:   { fr: 'Sol', en: 'Soil' },
    factor_frost:       { fr: 'Gel', en: 'Frost' },
    factor_precip:      { fr: 'Pluie (7j)', en: 'Rain (7d)' },
    factor_wind:        { fr: 'Vent', en: 'Wind' },
    factor_good:        { fr: 'Favorable', en: 'Favorable' },
    factor_caution:     { fr: 'Prudence', en: 'Caution' },
    factor_bad:         { fr: 'Défavorable', en: 'Unfavorable' },
    factor_no_frost:    { fr: 'Aucun gel prévu', en: 'No frost expected' },
    factor_frost_day:   { fr: 'Gel prévu jour {N}', en: 'Frost expected day {N}' },
    factor_precip_low:  { fr: 'Peu de pluie', en: 'Low rain' },
    factor_precip_mod:  { fr: 'Averses modérées', en: 'Moderate showers' },
    factor_precip_high: { fr: 'Averses abondantes', en: 'Heavy showers' },
    wait_tips:          { fr: 'En attendant, préparez votre terrain : aérez, nivelez, et amendez le sol.', en: 'In the meantime, prep your lawn: aerate, level, and amend the soil.' },
    wait_notify:        { fr: 'On vous préviendra quand les conditions seront idéales.', en: 'We\'ll notify you when conditions are ideal.' },
    seed_now_heading_caution: { fr: 'Vous voulez semer aujourd\'hui? Voici comment maximiser vos chances :', en: 'Want to seed today? Here\'s how to maximize your chances:' },
    seed_now_heading_wait:    { fr: 'Vous voulez quand même semer aujourd\'hui? Voici comment compenser :', en: 'Still want to seed today? Here\'s how to compensate:' },
    seed_now_heading_go:      { fr: 'Pour les meilleurs résultats aujourd\'hui :', en: 'For the best results today:' },
    season_reassure_title:    { fr: 'Pas d\'urgence', en: 'No rush' },
    season_reassure_spring:   { fr: 'La fenêtre de semis du printemps reste ouverte jusqu\'au {DATE}.', en: 'The spring seeding window stays open until {DATE}.' },
    season_reassure_fall:     { fr: 'La fenêtre d\'automne ouvre vers le {DATE}.', en: 'The fall window opens around {DATE}.' },
    season_reassure_both:     { fr: 'Vous avez deux fenêtres : printemps (jusqu\'au {SPRING}) et automne ({FALL_START}–{FALL_END}).', en: 'You have two windows: spring (through {SPRING}) and fall ({FALL_START}–{FALL_END}).' },
    season_reassure_both_single_fall: { fr: 'Vous avez deux fenêtres : printemps (jusqu\'au {SPRING}) et automne (en {FALL}).', en: 'You have two windows: spring (through {SPRING}) and fall (in {FALL}).' },
    season_reassure_weeks:    { fr: 'Encore {N} semaines de bonnes conditions cette saison.', en: '{N} more weeks of good conditions this season.' },
    season_reassure_days:     { fr: 'Encore {N} jours de bonnes conditions cette saison.', en: '{N} more days of good conditions this season.' },
    guard_text:         { fr: 'Vous avez déjà un suivi actif pour {BLEND} ({DAYS} jours). Remplacer?', en: 'You already have an active tracker for {BLEND} ({DAYS} days). Replace?' },
    guard_replace:      { fr: 'Remplacer', en: 'Replace' },
    guard_cancel:       { fr: 'Annuler', en: 'Cancel' }
  };

  /* --- Blend agronomic config --- */
  var BLEND_CONFIG = {
    ombre: {
      soil_temp_min: 10, soil_temp_optimal: [12, 22], frost_threshold: 2,
      germination: [7, 14],
      season_go: [5, 9], season_caution: [4, 6, 10], hard_block_months: [],
      coverage_new: 35, coverage_overseed: 70,
      rules: [
        { id: 'ombre_cloud_boost', type: 'go_boost', condition: 'cloud_cover_high', threshold: 85,
          fr: 'Temps couvert idéal pour l\'établissement d\'OMBRE — moins de stress hydrique.',
          en: 'Overcast conditions ideal for SHADE blend establishment — less moisture stress.' },
        { id: 'ombre_heat', type: 'caution', condition: 'heat_streak', threshold: 30, days: 3,
          fr: 'Chaleur intense prévue. OMBRE préfère les jours frais — attendez si possible.',
          en: 'Intense heat forecast. SHADE blend prefers cool days — wait if possible.' }
      ]
    },
    soleil: {
      soil_temp_min: 10, soil_temp_optimal: [10, 28], frost_threshold: 2,
      germination: [5, 10],
      season_go: [5, 6, 9], season_caution: [4, 7, 8, 10], hard_block_months: [],
      coverage_new: 35, coverage_overseed: 70,
      rules: []
    },
    aride: {
      soil_temp_min: 10, soil_temp_optimal: [12, 30], frost_threshold: 2,
      germination: [10, 18],
      season_go: [5, 6, 9], season_caution: [4, 7, 8, 10], hard_block_months: [],
      coverage_new: 30, coverage_overseed: 60,
      rules: [
        { id: 'aride_dry_boost', type: 'go_boost', condition: 'dry_forecast', threshold: 5,
          fr: 'ARIDE est formulé pour les conditions sèches — ces prévisions lui conviennent bien.',
          en: 'ARID is formulated for dry conditions — this forecast suits it well.' },
        { id: 'aride_dry_caution', type: 'caution', condition: 'dry_no_water',
          fr: 'ARIDE résiste à la sécheresse une fois établi, mais a besoin d\'humidité pour germer. Arrosez quotidiennement pendant 2 semaines.',
          en: 'ARID tolerates drought once established, but needs moisture to germinate. Water daily for 2 weeks.' }
      ]
    },
    vivant: {
      soil_temp_min: 12, soil_temp_optimal: [12, 24], frost_threshold: 2,
      germination: [7, 12],
      season_go: [5, 9], season_caution: [4, 6, 10], hard_block_months: [],
      coverage_new: 35, coverage_overseed: 70,
      rules: [
        { id: 'vivant_soil_strict', type: 'wait', condition: 'soil_temp_low', threshold: 12,
          fr: 'Sol encore trop froid pour le trèfle micro. Attendez 12°C au sol pour VIVANT.',
          en: 'Soil still too cold for micro-clover. Wait for 12°C soil temp for LIVING blend.' },
        { id: 'vivant_moisture_boost', type: 'go_boost', condition: 'rain_coming', threshold: 5,
          fr: 'Bonnes conditions d\'humidité — idéal pour la levée du trèfle.',
          en: 'Good moisture conditions — ideal for clover germination.' }
      ]
    },
    prairie: {
      soil_temp_min: 10, soil_temp_optimal: [10, 22], frost_threshold: 2,
      germination: [10, 21],
      season_go: [5], season_caution: [9], hard_block_months: [6, 7, 8, 10, 11, 12, 1, 2, 3],
      coverage_new: 20, coverage_overseed: null,
      rules: [
        { id: 'prairie_window', type: 'hard_block', condition: 'out_of_window',
          fr: 'PRAIRIE se sème uniquement en mai ou en septembre. La fenêtre actuelle ne convient pas à ce mélange.',
          en: 'MEADOW is sown only in May or September. The current window does not suit this blend.' },
        { id: 'prairie_late', type: 'caution', condition: 'after_date', threshold: '06-01',
          fr: 'Fin de fenêtre pour PRAIRIE. Idéalement semé avant le 1er juin. Possible, mais résultats moins prévisibles.',
          en: 'Late window for MEADOW. Ideally sown before June 1. Possible, but results less predictable.' },
        { id: 'prairie_wind', type: 'caution', condition: 'wind_high', threshold: 25,
          fr: 'Les graines de PRAIRIE sont légères. Semez par temps calme pour éviter la dispersion.',
          en: 'MEADOW seeds are light. Seed in calm weather to avoid dispersal.' }
      ]
    },
    golf: {
      soil_temp_min: 10, soil_temp_optimal: [16, 28], frost_threshold: 2,
      germination: [7, 14],
      season_go: [8, 9], season_caution: [5, 6, 10], hard_block_months: [11, 12, 1, 2, 3, 4, 7],
      coverage_new: 40, coverage_overseed: 80,
      rules: [
        { id: 'golf_off_season', type: 'hard_block', condition: 'out_of_window',
          fr: 'GOLF se sème en août ou septembre pour un gazon dense et fin façon terrain de golf. La période actuelle n\'est pas idéale.',
          en: 'GOLF is best sown in August or September for a dense, fine golf-course lawn. The current period is not ideal.' },
        { id: 'golf_peak', type: 'go_boost', condition: 'peak_months', months: [8, 9],
          fr: 'Fenêtre idéale pour GOLF — la chaleur de fin d\'été réchauffe le sol pour un établissement rapide d\'un gazon style terrain de golf.',
          en: 'Ideal window for GOLF — late-summer warmth lets the soil power a fast establishment of a golf-course-style lawn.' },
        { id: 'golf_spring', type: 'caution', condition: 'off_peak_spring', months: [5, 6],
          fr: 'Printemps possible pour GOLF, mais la fenêtre d\'août–septembre donne un résultat nettement plus dense.',
          en: 'Spring works for GOLF, but the August–September window produces a noticeably denser lawn.' },
        { id: 'golf_warm_soil', type: 'go_boost', condition: 'soil_warm', threshold: 16,
          fr: 'Sol bien chaud — idéal pour un démarrage rapide d\'un gazon style terrain de golf.',
          en: 'Soil nice and warm — ideal for a fast start on a golf-course-style lawn.' }
      ]
    },
    melange_b: {
      // Quick-establishment ground-cover / lawn mix: 55% fléole des prés (timothy), 30% trèfle rouge,
      // 15% trèfle Alsike. Cool- and moisture-tolerant — popular as a fast-cover lawn or bare-patch fix.
      // Same biology as the field mix but messaging stays in lawn/ground-cover language.
      soil_temp_min: 8, soil_temp_optimal: [10, 20], frost_threshold: 0,
      germination: [10, 21],
      season_go: [5, 8, 9], season_caution: [4, 6, 10], hard_block_months: [7, 11, 12, 1, 2, 3],
      rain_tolerant: true,
      coverage_new: 25, coverage_overseed: 50,
      rules: [
        { id: 'melange_b_off_season', type: 'hard_block', condition: 'out_of_window',
          fr: 'MÉLANGE-B s\'établit au printemps (mai–début juin) ou de la mi-août à la mi-septembre pour un couvre-sol rapide. Hors fenêtre actuellement.',
          en: 'MIX-B establishes in spring (May–early June) or mid-August to mid-September for a fast ground cover. Out of window right now.' },
        { id: 'melange_b_summer_heat', type: 'caution', condition: 'heat_streak', threshold: 28, days: 3,
          fr: 'Chaleur estivale — la levée rapide souffre et le couvre-sol prend mal. La fenêtre de fin d\'été est plus fiable.',
          en: 'Summer heat — fast germination suffers and the cover thins. The late-summer window is more reliable.' },
        { id: 'melange_b_late_summer_peak', type: 'go_boost', condition: 'peak_months', months: [8, 9],
          fr: 'Fenêtre idéale — sol chaud, nuits fraîches : levée rapide pour un couvre-sol bien établi avant l\'hiver.',
          en: 'Ideal window — warm soil, cool nights: fast germination for a ground cover well established before winter.' },
        { id: 'melange_b_moisture_boost', type: 'go_boost', condition: 'rain_coming', threshold: 4,
          fr: 'Bonne humidité prévue — idéal pour une levée rapide et un couvre-sol uniforme.',
          en: 'Good moisture forecast — ideal for fast germination and even cover.' }
      ]
    }
  };

  /* --- Seed-now compensating tactics ---
     Goal: never discourage a sale. When conditions are marginal/unfavorable, give the customer
     concrete, actionable advice on how to make seeding TODAY work. Each tip is keyed on a signal
     condition the engine can detect. The renderer picks the 2–3 most relevant tips for the
     current verdict and forecast. Tone: practical, not preachy. */
  var SEED_NOW_TIPS = {
    cold_soil: {
      fr: { title: 'Sol froid', body: 'Couvrez la zone semée avec un voile de protection (Reemay) ou une bâche transparente : ça réchauffe le sol de 2–3°C et accélère la levée d\'environ une semaine. Augmentez le taux de semis d\'environ 25 % pour compenser les pertes.' },
      en: { title: 'Cold soil', body: 'Cover the seeded area with a row cover (Reemay) or clear tarp: it lifts soil temp 2–3°C and speeds germination by about a week. Increase the seeding rate ~25 % to offset losses.' }
    },
    frost_risk: {
      fr: { title: 'Risque de gel', body: 'Si une nuit à -2°C ou moins est prévue, couvrez avec un voile de protection avant le coucher du soleil et retirez-le en mi-journée. Évitez de semer le matin du jour de gel — privilégiez les après-midis.' },
      en: { title: 'Frost risk', body: 'If a night below -2°C is forecast, cover with row cover before sunset and pull it back midday. Avoid seeding the morning of a frost day — sow in the afternoon instead.' }
    },
    heavy_rain: {
      fr: { title: 'Forte pluie prévue', body: 'Semez en surface, puis ratissez très légèrement (1–2 cm) — ne roulez pas le sol, ça scelle la surface. Si vous prévoyez ≥ 25 mm en 48 h, attendez que la pluie passe pour éviter que les semences soient lavées.' },
      en: { title: 'Heavy rain expected', body: 'Sow on the surface and rake lightly (1–2 cm) — don\'t roll the soil, it seals the surface. If 25+ mm is forecast in 48 h, wait for the storm to pass so seeds aren\'t washed out.' }
    },
    waterlogged: {
      fr: { title: 'Sol détrempé aujourd\'hui', body: 'Si vos pas laissent des marques d\'eau, attendez 24–48 h. Sinon, ratissez très légèrement la surface pour aérer avant de semer. Évitez le roulage qui scelle un sol gorgé.' },
      en: { title: 'Soil waterlogged today', body: 'If your footsteps leave water marks, wait 24–48 h. Otherwise, rake the surface lightly to aerate before sowing. Skip the roller — it seals saturated soil.' }
    },
    dry_heat: {
      fr: { title: 'Conditions sèches', body: 'Arrosez le sol la veille pour humidifier en profondeur, puis arrosez 2 fois par jour (matin et soir) pendant 14 jours. Une couche de paille fine (1 cm) retient l\'humidité sans bloquer la lumière.' },
      en: { title: 'Dry conditions', body: 'Pre-water the area the day before to soak the soil, then water twice daily (morning + evening) for 14 days. A thin straw mulch (1 cm) holds moisture without blocking light.' }
    },
    wind: {
      fr: { title: 'Vent', body: 'Semez en avant-midi quand le vent retombe. Mélangez les graines avec du sable fin (ratio 1:4) pour un meilleur contrôle de la dispersion. Couvrez d\'un voile léger après le semis pour retenir les graines.' },
      en: { title: 'Wind', body: 'Sow in the morning when the wind drops. Mix seeds with fine sand (1:4 ratio) for better dispersal control. Cover with a light row cover after sowing to keep seeds in place.' }
    },
    off_season: {
      fr: { title: 'Hors fenêtre principale', body: 'Vous pouvez quand même semer, mais attendez-vous à un établissement plus lent et à un sursemis nécessaire. Augmentez le taux de semis de 30–40 % et arrosez quotidiennement les 3 premières semaines.' },
      en: { title: 'Outside the main window', body: 'You can still seed, but expect slower establishment and likely overseeding later. Increase the rate 30–40 % and water daily for the first 3 weeks.' }
    },
    best_practice: {
      fr: { title: 'Bonnes pratiques', body: 'Ratissez le sol à 1–2 cm avant de semer. Roulez légèrement après pour bon contact graine-sol. Arrosez en pluie fine 1–2 fois par jour les 14 premiers jours, jusqu\'à la levée.' },
      en: { title: 'Best practices', body: 'Rake the soil to 1–2 cm before sowing. Roll lightly afterward for good seed–soil contact. Mist water 1–2 times daily for the first 14 days until germination.' }
    }
  };

  /* --- Discount / promo config (placeholder — activate when promo is live) --- */
  var DISCOUNT_CONFIG = {
    active: false,
    code: '',
    percent: 0,
    message: { fr: '', en: '' },
    blends: []   // empty = all blends, or ['ombre','soleil'] etc.
  };

  /* --- Seasonal fallback table (month → blend → status) --- */
  var SEASONAL_FALLBACK = {
    1:  { ombre:'wait', soleil:'wait', aride:'wait', vivant:'wait', prairie:'wait', golf:'wait', melange_b:'wait' },
    2:  { ombre:'wait', soleil:'wait', aride:'wait', vivant:'wait', prairie:'wait', golf:'wait', melange_b:'wait' },
    3:  { ombre:'wait', soleil:'wait', aride:'wait', vivant:'wait', prairie:'wait', golf:'wait', melange_b:'wait' },
    4:  { ombre:'caution', soleil:'caution', aride:'caution', vivant:'caution', prairie:'wait', golf:'wait', melange_b:'caution' },
    5:  { ombre:'go', soleil:'go', aride:'go', vivant:'go', prairie:'go', golf:'wait', melange_b:'go' },
    6:  { ombre:'caution', soleil:'go', aride:'go', vivant:'caution', prairie:'caution', golf:'wait', melange_b:'caution' },
    7:  { ombre:'wait', soleil:'caution', aride:'caution', vivant:'wait', prairie:'wait', golf:'wait', melange_b:'wait' },
    8:  { ombre:'wait', soleil:'caution', aride:'caution', vivant:'wait', prairie:'wait', golf:'go', melange_b:'go' },
    9:  { ombre:'go', soleil:'go', aride:'go', vivant:'go', prairie:'wait', golf:'go', melange_b:'go' },
    10: { ombre:'caution', soleil:'caution', aride:'caution', vivant:'caution', prairie:'wait', golf:'caution', melange_b:'caution' },
    11: { ombre:'wait', soleil:'wait', aride:'wait', vivant:'wait', prairie:'wait', golf:'wait', melange_b:'wait' },
    12: { ombre:'wait', soleil:'wait', aride:'wait', vivant:'wait', prairie:'wait', golf:'wait', melange_b:'wait' }
  };

  /* Per-blend × per-status fallback messaging — used when the weather API is unavailable.
     Goal: explain WHY (signal the merchant has) and WHAT TO DO (when to come back).
     Keys: blend slug → { go|caution|wait → {fr, en} }. Falls back to a generic line if missing. */
  var FALLBACK_MESSAGES = {
    ombre: {
      go:      { fr: 'Fenêtre de printemps ou de fin d\'été — c\'est habituellement le moment de semer OMBRE au Québec.',
                 en: 'Spring or late-summer window — usually the right time to seed SHADE in Quebec.' },
      caution: { fr: 'Période marginale pour OMBRE — sol souvent encore froid au début mai et chaud en juin. Vérifiez le sol au-dessus de 10°C avant de semer.',
                 en: 'Marginal period for SHADE — soil often still cold in early May and hot in June. Check that soil is above 10°C before sowing.' },
      wait:    { fr: 'Hors saison pour OMBRE. Visez fin avril–mai pour le printemps, ou début septembre pour le sursemis automnal.',
                 en: 'Out of season for SHADE. Aim for late April–May in spring, or early September for fall overseed.' }
    },
    soleil: {
      go:      { fr: 'Fenêtre de printemps ou de fin d\'été — SOLEIL s\'établit bien quand le sol dépasse 10°C avec quelques jours sans gel.',
                 en: 'Spring or late-summer window — SUN establishes well when soil clears 10°C with a few frost-free days.' },
      caution: { fr: 'Période marginale pour SOLEIL — début mai souvent trop froid au sol, fin juin et juillet trop chauds. Visez 10–18°C au sol.',
                 en: 'Marginal period for SUN — early May often too cold at soil level; late June and July too hot. Aim for 10–18°C soil.' },
      wait:    { fr: 'Hors saison pour SOLEIL. Visez la mi-mai à juin pour le printemps, ou septembre pour la fenêtre d\'automne.',
                 en: 'Out of season for SUN. Aim for mid-May to June in spring, or September for the fall window.' }
    },
    aride: {
      go:      { fr: 'Bonne fenêtre pour ARIDE — formulé pour les sols secs, mais a besoin d\'humidité constante pour la levée.',
                 en: 'Good window for ARID — built for dry soils, but needs steady moisture for germination.' },
      caution: { fr: 'Période marginale pour ARIDE — vérifiez la température du sol et prévoyez d\'arroser quotidiennement les 2 premières semaines.',
                 en: 'Marginal period for ARID — check soil temperature and plan to water daily the first 2 weeks.' },
      wait:    { fr: 'Hors saison pour ARIDE. Visez fin mai–juin pour le printemps, ou septembre.',
                 en: 'Out of season for ARID. Aim for late May–June in spring, or September.' }
    },
    vivant: {
      go:      { fr: 'Fenêtre de printemps ou de fin d\'été — VIVANT exige un sol à 12°C minimum (le trèfle micro est plus exigeant).',
                 en: 'Spring or late-summer window — LIVING needs at least 12°C soil (micro-clover is fussier).' },
      caution: { fr: 'Période marginale pour VIVANT — sol probablement encore sous 12°C. Le trèfle germe lentement en sol froid.',
                 en: 'Marginal period for LIVING — soil likely still under 12°C. Clover germinates slowly in cold soil.' },
      wait:    { fr: 'Hors saison pour VIVANT. Visez la mi-mai à juin (sol à 12°C+) ou septembre.',
                 en: 'Out of season for LIVING. Aim for mid-May to June (soil 12°C+) or September.' }
    },
    prairie: {
      go:      { fr: 'Fenêtre de mai pour PRAIRIE — semez tôt dans le mois pour laisser le temps aux fleurs de s\'établir avant la chaleur.',
                 en: 'May window for MEADOW — sow early in the month to give wildflowers time to establish before the heat.' },
      caution: { fr: 'Fin de fenêtre pour PRAIRIE. Possible jusqu\'à début juin, mais résultats moins prévisibles.',
                 en: 'Late window for MEADOW. Possible through early June, but results less predictable.' },
      wait:    { fr: 'PRAIRIE se sème uniquement en mai (fenêtre courte au Québec). Revenez au printemps prochain.',
                 en: 'MEADOW only sows in May (short Quebec window). Check back next spring.' }
    },
    golf: {
      go:      { fr: 'Fenêtre idéale pour GOLF — août–septembre donnent le gazon le plus dense et le plus fin.',
                 en: 'Ideal window for GOLF — August–September deliver the densest, finest lawn.' },
      caution: { fr: 'Fenêtre marginale pour GOLF. Le résultat sera meilleur en août–septembre, sol chaud, nuits fraîches.',
                 en: 'Marginal window for GOLF. Results are noticeably better in August–September with warm soil and cool nights.' },
      wait:    { fr: 'Hors saison pour GOLF. Visez août ou septembre pour un gazon style terrain de golf bien établi.',
                 en: 'Out of season for GOLF. Aim for August or September for a well-established golf-course-style lawn.' }
    },
    melange_b: {
      go:      { fr: 'Bonne fenêtre pour MÉLANGE-B — levée rapide pour un couvre-sol uniforme avant la chaleur estivale ou avant l\'hiver.',
                 en: 'Good window for MIX-B — fast germination for an even ground cover before summer heat or before winter.' },
      caution: { fr: 'Période marginale pour MÉLANGE-B — sol probablement encore froid. Tolère le sol humide, mais pas le gel.',
                 en: 'Marginal period for MIX-B — soil likely still cold. Tolerates wet soil, but not frost.' },
      wait:    { fr: 'Hors saison pour MÉLANGE-B. Visez fin avril–début juin (printemps) ou mi-août–mi-septembre pour un couvre-sol rapide.',
                 en: 'Out of season for MIX-B. Aim for late April–early June (spring) or mid-August to mid-September for a fast ground cover.' }
    }
  };

  /* --- Weather code → icon mapping (4 states) --- */
  var WEATHER_ICONS = {
    sunny: '<svg viewBox="0 0 24 24" fill="none" stroke="#E8C547" stroke-width="2"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>',
    cloudy: '<svg viewBox="0 0 24 24" fill="none" stroke="#9E9E9E" stroke-width="2"><path d="M18 10h-1.26A8 8 0 109 20h9a5 5 0 000-10z"/></svg>',
    rain: '<svg viewBox="0 0 24 24" fill="none" stroke="#5B9BD5" stroke-width="2"><path d="M16 13V21M8 13V21M12 15V23M20 8h-1.26A8 8 0 107 16h13a5 5 0 000-10z"/></svg>',
    snow: '<svg viewBox="0 0 24 24" fill="none" stroke="#B0C4DE" stroke-width="2"><path d="M20 17.58A5 5 0 0018 8h-1.26A8 8 0 104 16.25M8 16h.01M8 20h.01M12 18h.01M12 22h.01M16 16h.01M16 20h.01"/></svg>'
  };

  function weatherCodeToIcon(code) {
    if (!code) return WEATHER_ICONS.cloudy;
    // Tomorrow.io weather codes: 1000-1100 = clear/sunny, 1101-1102 = partly cloudy,
    // 2000-2100 = fog, 4000-4201 = rain, 5000-5101 = snow, 6000-6201 = freezing rain
    if (code >= 5000) return WEATHER_ICONS.snow;
    if (code >= 4000) return WEATHER_ICONS.rain;
    if (code <= 1001) return WEATHER_ICONS.sunny;
    return WEATHER_ICONS.cloudy;
  }

  /* ============================================================
     STATE
     ============================================================ */
  var state = {
    blend: null,
    postalCode: null,
    fsa: null,
    coords: null,
    siteName: null,            // optional free-text — "where are you seeding?"
    forecast: null,
    lastStatus: null,
    customerName: null,
    customerEmail: null,
    lang: LANG
  };
  window.__SEMER_STATE = state;

  var CONFIG = null;
  var FSA_DATA = null;

  /* ============================================================
     DOM REFERENCES
     ============================================================ */
  var DOM = {};

  function cacheDom() {
    DOM.app = document.getElementById('smr-app');
    DOM.greeting = document.getElementById('smr-greeting');
    DOM.headline = document.getElementById('smr-headline');
    DOM.blendsLabel = document.getElementById('smr-blends-label');
    DOM.blendButtons = document.querySelectorAll('[data-smr-blend]');
    DOM.postalInput = document.getElementById('smr-postal-input');
    DOM.postalModify = document.getElementById('smr-postal-modify');
    DOM.postalError = document.getElementById('smr-postal-error');
    DOM.loginPrompt = document.getElementById('smr-login-prompt');
    DOM.loginLink = document.getElementById('smr-login-link');
    DOM.cta = document.getElementById('smr-cta');
    DOM.loadingText = document.getElementById('smr-loading-text');
    DOM.verdict = document.getElementById('smr-verdict');
    DOM.verdictChip = document.getElementById('smr-verdict-chip');
    DOM.verdictIcon = document.getElementById('smr-verdict-icon');
    DOM.verdictStatus = document.getElementById('smr-verdict-status');
    DOM.verdictMessage = document.getElementById('smr-verdict-message');
    DOM.verdictDetail = document.getElementById('smr-verdict-detail');
    DOM.verdictFactors = document.getElementById('smr-verdict-factors');
    DOM.factorsToggle = document.getElementById('smr-factors-toggle');
    DOM.factorsGrid = document.getElementById('smr-factors-grid');
    DOM.waitTips = document.getElementById('smr-verdict-wait-tips');
    DOM.window = document.getElementById('smr-window');
    DOM.seedNow = document.getElementById('smr-seed-now');
    DOM.seedNowHeading = document.getElementById('smr-seed-now-heading');
    DOM.seedNowList = document.getElementById('smr-seed-now-list');
    DOM.reassure = document.getElementById('smr-reassure');
    DOM.reassureTitle = document.getElementById('smr-reassure-title');
    DOM.reassureBody = document.getElementById('smr-reassure-body');
    DOM.next = document.getElementById('smr-next');
    DOM.nextHeading = document.getElementById('smr-next-heading');
    DOM.nextCollection = document.getElementById('smr-next-collection');
    DOM.nextCopy = document.getElementById('smr-next-copy');
    DOM.siteInput = document.getElementById('smr-site-input');
    DOM.siteLabel = document.getElementById('smr-site-label');
    DOM.siteHint = document.getElementById('smr-site-hint');
    DOM.postalLabel = document.getElementById('smr-postal-label');
    DOM.postalHint = document.getElementById('smr-postal-hint');
    DOM.context = document.getElementById('smr-context');
    DOM.contextLabel = document.getElementById('smr-context-label');
    DOM.contextSite = document.getElementById('smr-context-site');
    DOM.contextSep = document.getElementById('smr-context-sep');
    DOM.contextPostal = document.getElementById('smr-context-postal');
    DOM.forecastLabel = document.getElementById('smr-forecast-label');
    DOM.forecast = document.getElementById('smr-forecast');
    DOM.cacheNotice = document.getElementById('smr-cache-notice');
    DOM.productLink = document.getElementById('smr-product-link');
    DOM.seedingCta = document.getElementById('smr-seeding-cta');
    DOM.errorMessage = document.getElementById('smr-error-message');
    DOM.errorRetry = document.getElementById('smr-error-retry');
    DOM.capture = document.getElementById('smr-capture');
    DOM.captureHeadline = document.getElementById('smr-capture-headline');
    DOM.captureSubline = document.getElementById('smr-capture-subline');
    DOM.captureEmail = document.getElementById('smr-capture-email');
    DOM.caslCheck = document.getElementById('smr-casl-check');
    DOM.captureSubmit = document.getElementById('smr-capture-submit');
    DOM.accountLink = document.getElementById('smr-account-link');
    DOM.tools = document.getElementById('smr-tools');
    DOM.tracker = document.getElementById('smr-tracker');
    DOM.resultBack = document.getElementById('smr-result-back');
    DOM.fastTrack = document.getElementById('smr-fast-track');
    DOM.fastTrackText = document.getElementById('smr-fast-track-text');
    DOM.fastTrackBtn = document.getElementById('smr-fast-track-btn');
    DOM.fastTrackDismiss = document.getElementById('smr-fast-track-dismiss');
    DOM.quickBuy = document.getElementById('smr-quick-buy');
    DOM.quickBuyLabel = document.getElementById('smr-quick-buy-label');
    DOM.quickBuySizes = document.getElementById('smr-quick-buy-sizes');
    DOM.quickBuyAtc = document.getElementById('smr-quick-buy-atc');
    DOM.quickBuyNote = document.getElementById('smr-quick-buy-note');
    DOM.quickBuyPdp = document.getElementById('smr-quick-buy-pdp');
    DOM.seedingGuard = document.getElementById('smr-seeding-guard');
    DOM.seedingGuardText = document.getElementById('smr-seeding-guard-text');
    DOM.seedingGuardReplace = document.getElementById('smr-seeding-guard-replace');
    DOM.seedingGuardCancel = document.getElementById('smr-seeding-guard-cancel');
  }

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    cacheDom();
    loadConfig();
    applyLanguage();
    readURLParams();
    loadFSAData();
    bindEvents();
    checkCustomerHook();
    checkExistingTracker();
  }

  function loadConfig() {
    var el = document.getElementById('smr-config');
    if (el) {
      try { CONFIG = JSON.parse(el.textContent); } catch (e) { CONFIG = {}; }
    }
  }

  /* --- Effective month: applies the merchant-configured season offset.
         Used to push timing later in cold/wet years (e.g. spring 2026).
         Only affects calendar/month-based rules; live weather data is unaffected. --- */
  function seasonOffsetWeeks() {
    var w = CONFIG && CONFIG.season_offset_weeks;
    return (typeof w === 'number' && w > 0) ? w : 0;
  }
  function effectiveMonth(date) {
    var offset = seasonOffsetWeeks();
    if (!offset) return (date || new Date()).getMonth() + 1;
    var d = new Date((date || new Date()).getTime() - offset * 7 * 86400000);
    return d.getMonth() + 1;
  }

  function applyLanguage() {
    if (LANG === 'en') {
      DOM.headline.textContent = UI.headline.en;
      DOM.blendsLabel.textContent = UI.blend_label.en;
      DOM.postalInput.placeholder = UI.postal_placeholder.en;
      DOM.cta.textContent = UI.cta.en;
      DOM.loadingText.textContent = UI.loading.en;
      DOM.forecastLabel.textContent = UI.forecast_label.en;
      DOM.seedingCta.textContent = UI.seeding_cta.en;
      DOM.errorMessage.textContent = UI.error_api.en;
      DOM.errorRetry.textContent = UI.error_retry.en;
    }
    // Always set the new field labels/hints (FR or EN) — these have no schema fallback.
    if (DOM.siteLabel) DOM.siteLabel.textContent = pick(UI.site_label);
    if (DOM.siteHint)  DOM.siteHint.textContent  = pick(UI.site_hint);
    if (DOM.siteInput) DOM.siteInput.placeholder = pick(UI.site_placeholder);
    if (DOM.postalLabel) DOM.postalLabel.textContent = pick(UI.postal_label);
    if (DOM.postalHint)  DOM.postalHint.textContent  = pick(UI.postal_hint);
  }

  function readURLParams() {
    var params = new URLSearchParams(window.location.search);
    var blend = params.get('blend');
    if (blend && BLEND_CONFIG[blend]) {
      selectBlend(blend);
      // Pulse animation for pre-selected
      var btn = document.querySelector('[data-smr-blend="' + blend + '"]');
      if (btn) {
        setTimeout(function () { btn.classList.add('smr-blend--pulse'); }, 100);
      }
    }
  }

  function loadFSAData() {
    if (!CONFIG || !CONFIG.fsa_url) return;
    // Check sessionStorage cache first (24h TTL)
    var cached = sessionStorage.getItem('smr-fsa-data');
    if (cached) {
      try {
        var parsed = JSON.parse(cached);
        if (Date.now() - parsed.ts < 86400000) {
          FSA_DATA = parsed.data;
          return;
        }
      } catch (e) { /* ignore */ }
    }
    fetch(CONFIG.fsa_url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        FSA_DATA = data;
        sessionStorage.setItem('smr-fsa-data', JSON.stringify({ ts: Date.now(), data: data }));
      })
      .catch(function () { FSA_DATA = null; });
  }

  /* --- Customer login hook (future Shopify app integration) --- */
  function checkCustomerHook() {
    if (window.__TERRAIN_CUSTOMER) {
      applyCustomerData(window.__TERRAIN_CUSTOMER);
      return;
    }
    // Wait up to 2s for async injection
    var waited = 0;
    var interval = setInterval(function () {
      waited += 200;
      if (window.__TERRAIN_CUSTOMER) {
        clearInterval(interval);
        applyCustomerData(window.__TERRAIN_CUSTOMER);
      } else if (waited >= 2000) {
        clearInterval(interval);
        // Login prompt now shown on postal code focus instead (see bindEvents)
      }
    }, 200);
  }

  function applyCustomerData(customer) {
    if (customer.firstName) {
      state.customerName = customer.firstName;
      DOM.greeting.textContent = UI.greeting[LANG].replace('{NAME}', customer.firstName);
      DOM.greeting.hidden = false;
    }
    if (customer.email) {
      state.customerEmail = customer.email;
    }
    if (customer.postalCode) {
      state.postalCode = customer.postalCode.toUpperCase().replace(/\s/g, '');
      DOM.postalInput.value = formatPostalCode(state.postalCode);
      DOM.postalInput.readOnly = true;
      DOM.postalModify.hidden = false;
      validateAndEnableCta();
    }
  }

  function checkExistingTracker() {
    var record = safeStorageGet('smr-seeding-record');
    if (record) {
      try {
        var data = JSON.parse(record);
        // If seeding was within the last 30 days, show tracker
        var daysSince = Math.floor((Date.now() - new Date(data.date).getTime()) / 86400000);
        if (daysSince <= 30 && data.blend) {
          state.blend = data.blend;

          // Pre-select the blend UI
          selectBlend(data.blend);

          // Pre-fill postal code for anonymous users
          if (data.postalCode && !window.__TERRAIN_CUSTOMER) {
            DOM.postalInput.value = formatPostalCode(data.postalCode);
            validateAndEnableCta();
          }

          // Show fast-track banner
          renderFastTrack(data, daysSince);
        }
      } catch (e) { /* ignore */ }
    }
  }

  function renderFastTrack(data, daysSince) {
    if (!DOM.fastTrack) return;

    var blendName = data.blend ? data.blend.toUpperCase() : '';
    var blendConfig = getBlendInfo(data.blend);
    if (blendConfig && blendConfig.name_fr) {
      blendName = LANG === 'en' ? (blendConfig.name_en || blendConfig.name_fr) : blendConfig.name_fr;
    }

    var dateStr = data.date || '';
    if (dateStr) {
      var d = new Date(dateStr);
      dateStr = d.getDate() + '/' + (d.getMonth() + 1);
    }

    DOM.fastTrackText.textContent = pick(UI.fast_track_text).replace('{BLEND}', blendName).replace('{DATE}', dateStr);
    DOM.fastTrackBtn.textContent = pick(UI.fast_track_btn);
    DOM.fastTrackDismiss.textContent = pick(UI.fast_track_dismiss);

    DOM.fastTrackBtn.addEventListener('click', function () {
      // Auto-submit with saved data
      if (data.postalCode) {
        state.postalCode = data.postalCode;
        DOM.postalInput.value = formatPostalCode(data.postalCode);
      }
      state.blend = data.blend;
      handleSubmit();
    });

    DOM.fastTrackDismiss.addEventListener('click', function () {
      DOM.fastTrack.hidden = true;
    });

    DOM.fastTrack.hidden = false;
  }

  /* ============================================================
     EVENT BINDING
     ============================================================ */
  function bindEvents() {
    // Blend selection
    DOM.blendButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectBlend(btn.getAttribute('data-smr-blend'));
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectBlend(btn.getAttribute('data-smr-blend'));
        }
      });
    });

    // Postal code auto-format
    DOM.postalInput.addEventListener('input', function () {
      var raw = DOM.postalInput.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
      if (raw.length > 3) {
        DOM.postalInput.value = raw.slice(0, 3) + ' ' + raw.slice(3, 6);
      } else {
        DOM.postalInput.value = raw;
      }
      DOM.postalError.textContent = '';
      DOM.postalInput.classList.remove('smr-postal__field--error');
      validateAndEnableCta();
    });

    // Postal code enter key
    DOM.postalInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !DOM.cta.disabled) {
        e.preventDefault();
        handleSubmit();
      }
    });

    // Modify postal code
    DOM.postalModify.addEventListener('click', function () {
      DOM.postalInput.readOnly = false;
      DOM.postalInput.focus();
      DOM.postalModify.hidden = true;
    });

    // CTA button
    DOM.cta.addEventListener('click', handleSubmit);

    // Error retry
    DOM.errorRetry.addEventListener('click', function () {
      setState('input');
    });

    // CASL checkbox enables capture submit
    DOM.caslCheck.addEventListener('change', function () {
      DOM.captureSubmit.disabled = !DOM.caslCheck.checked || !DOM.captureEmail.value;
    });
    DOM.captureEmail.addEventListener('input', function () {
      DOM.captureSubmit.disabled = !DOM.caslCheck.checked || !DOM.captureEmail.value;
    });

    // Capture submit
    DOM.captureSubmit.addEventListener('click', handleEmailCapture);

    // Seeding CTA
    DOM.seedingCta.addEventListener('click', handleSeedingConfirmation);

    // Back to input from result state
    if (DOM.resultBack) {
      DOM.resultBack.addEventListener('click', function () {
        // Reset result-state elements for clean re-entry
        DOM.capture.hidden = true;
        DOM.seedingCta.hidden = false;
        if (DOM.quickBuy) DOM.quickBuy.hidden = true;
        if (DOM.tools) DOM.tools.hidden = true;
        if (DOM.tracker) DOM.tracker.hidden = true;
        setState('input');
      });
    }

    // Show login prompt on postal code focus for anonymous users only
    DOM.postalInput.addEventListener('focus', function () {
      if (!window.__TERRAIN_CUSTOMER && !DOM.postalInput.value) {
        DOM.loginPrompt.hidden = false;
      }
    });
  }

  /* ============================================================
     BLEND SELECTION
     ============================================================ */
  function selectBlend(slug) {
    state.blend = slug;
    DOM.blendButtons.forEach(function (btn) {
      var selected = btn.getAttribute('data-smr-blend') === slug;
      btn.classList.toggle('smr-blend--selected', selected);
      btn.setAttribute('aria-checked', selected ? 'true' : 'false');
    });
    // Update login link with blend param
    DOM.loginLink.href = '/account/login?return_url=/pages/semer?blend=' + slug;
    validateAndEnableCta();
  }

  /* ============================================================
     VALIDATION
     ============================================================ */
  var CA_POSTAL = /^[A-Za-z]\d[A-Za-z]\d[A-Za-z]\d$/;

  function validateAndEnableCta() {
    var raw = DOM.postalInput.value.replace(/\s/g, '');
    var hasBlend = !!state.blend;
    var hasPostal = raw.length >= 6;
    DOM.cta.disabled = !(hasBlend && hasPostal);
  }

  function formatPostalCode(raw) {
    raw = raw.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (raw.length > 3) return raw.slice(0, 3) + ' ' + raw.slice(3, 6);
    return raw;
  }

  function validatePostalCode(raw) {
    raw = raw.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (!CA_POSTAL.test(raw)) {
      showPostalError(UI.error_format[LANG]);
      return null;
    }
    var fsa = raw.slice(0, 3);
    // Quebec FSAs start with G, H, or J
    if (!/^[GHJ]/.test(fsa)) {
      showPostalError(UI.error_not_qc[LANG]);
      return null;
    }
    if (!FSA_DATA || !FSA_DATA[fsa]) {
      showPostalError(UI.error_not_qc[LANG]);
      return null;
    }
    return { raw: raw, fsa: fsa, lat: FSA_DATA[fsa][0], lng: FSA_DATA[fsa][1] };
  }

  function showPostalError(msg) {
    DOM.postalError.textContent = msg;
    DOM.postalInput.classList.add('smr-postal__field--error');
  }

  /* ============================================================
     STATE MACHINE
     ============================================================ */
  function setState(name) {
    DOM.app.setAttribute('data-state', name);
    // Announce state changes to screen readers
    var announcer = document.getElementById('smr-announcer');
    if (announcer) {
      var msgs = { loading: UI.loading[LANG], error: UI.error_api[LANG] };
      announcer.textContent = msgs[name] || '';
    }
    // Re-trigger CSS entrance animations for result state (handles back→resubmit)
    if (name === 'result') {
      DOM.app.querySelectorAll('.smr-verdict, .smr-window, .smr-forecast, .smr-actions, .smr-result__back').forEach(function(el) {
        el.style.animation = 'none';
        el.offsetHeight; // force reflow
        el.style.animation = '';
      });
    }
  }

  /* ============================================================
     SUBMIT — MAIN FLOW
     ============================================================ */
  function handleSubmit() {
    var raw = DOM.postalInput.value.replace(/\s/g, '');
    var postal = validatePostalCode(raw);
    if (!postal) return;

    state.postalCode = postal.raw;
    state.fsa = postal.fsa;
    state.coords = { lat: postal.lat, lng: postal.lng };
    // Optional site name — trim and cap defensively
    if (DOM.siteInput) {
      var siteRaw = (DOM.siteInput.value || '').trim();
      state.siteName = siteRaw ? siteRaw.slice(0, 60) : null;
    }

    setState('loading');
    var stopLoadingCycle = startLoadingCycle();

    // Pace the reveal so the analysis feels deliberate even on cache hits.
    // The actual API call still runs in parallel — we just wait for both.
    var minDelay = new Promise(function (r) { setTimeout(r, 2200); });
    var fetchPromise = fetchForecast(postal.lat, postal.lng, postal.fsa);

    Promise.all([fetchPromise, minDelay])
      .then(function (arr) {
        stopLoadingCycle();
        var result = arr[0];
        if (result.forecast) {
          state.forecast = result.forecast;
          var evaluation = evaluateRules(result.forecast, state.blend);
          renderResult(evaluation, result.forecast, result.source, result.cacheAge);
          setState('result');
        } else {
          var fallback = getSeasonalFallback(state.blend);
          renderFallbackResult(fallback);
          setState('result');
        }
      })
      .catch(function () {
        stopLoadingCycle();
        var fallback = getSeasonalFallback(state.blend);
        renderFallbackResult(fallback);
        setState('result');
      });
  }

  /* Cycles the loading-text element through a sequence of analysis steps.
     Returns a stop function that the caller invokes once the result is ready. */
  function startLoadingCycle() {
    if (!DOM.loadingText) return function () {};
    var steps = UI.loading_steps[LANG];
    var i = 0;
    DOM.loadingText.textContent = steps[0];
    var interval = setInterval(function () {
      i = Math.min(i + 1, steps.length - 1);
      DOM.loadingText.textContent = steps[i];
    }, 500);
    return function () { clearInterval(interval); };
  }

  /* ============================================================
     WEATHER API — TOMORROW.IO
     ============================================================ */
  function fetchForecast(lat, lng, fsa) {
    // Check sessionStorage cache first (3h TTL)
    var cacheKey = 'smr-weather-' + fsa;
    var cached = sessionStorage.getItem(cacheKey);
    if (cached) {
      try {
        var parsed = JSON.parse(cached);
        if (Date.now() - parsed.ts < 10800000) { // 3 hours
          return Promise.resolve({ forecast: parsed.data, source: 'cache', cacheAge: Date.now() - parsed.ts });
        }
      } catch (e) { /* ignore */ }
    }

    if (!CONFIG || !CONFIG.tomorrow_key) {
      return Promise.resolve({ forecast: null, source: 'no_key' });
    }

    // Tomorrow.io Free / Basic tier restrictions we work around here:
    //  • Soil fields (soilTemperature0To10, soilMoistureVolumetric0To10) → 403. Derived below
    //    from a rolling air-temp average (~2 °C accurate spring proxy).
    //  • Forecast horizon capped at 5 days (free tier rejects >5 day endTime). The renderer
    //    handles whatever number of intervals come back; on Pro/Enterprise this can go to
    //    nowPlus10d for the original 10-day strip.
    var url = 'https://api.tomorrow.io/v4/timelines'
      + '?location=' + lat + ',' + lng
      + '&fields=temperatureMax,temperatureMin,precipitationIntensityAvg,windSpeedMax,weatherCodeMax,cloudCoverAvg'
      + '&timesteps=1d'
      + '&units=metric'
      + '&timezone=America/Toronto'
      + '&startTime=now'
      + '&endTime=nowPlus5d'
      + '&apikey=' + CONFIG.tomorrow_key;

    // Cold-cache requests to api.tomorrow.io can take 2–4 s on first hit (DNS + TLS handshake);
    // subsequent calls are cached for 3 h in sessionStorage. 8 s gives the cold path room without
    // making the user wait too long if the API is genuinely down.
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 8000);

    return fetch(url, { signal: controller.signal })
      .then(function (r) {
        clearTimeout(timeout);
        if (!r.ok) throw new Error('API error ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var intervals = data && data.data && data.data.timelines && data.data.timelines[0] && data.data.timelines[0].intervals;
        if (!intervals || !intervals.length) throw new Error('No data');

        var forecast = intervals.map(function (d) {
          var v = d.values;
          return {
            date: d.startTime.slice(0, 10),
            tempMax: v.temperatureMax,
            tempMin: v.temperatureMin,
            precipAvg: v.precipitationIntensityAvg,
            windMax: v.windSpeedMax,
            weatherCode: v.weatherCodeMax,
            soilTemp: v.soilTemperature0To10,            // null on Free tier — filled by proxy below
            soilMoisture: v.soilMoistureVolumetric0To10, // null on Free tier
            cloudCover: v.cloudCoverAvg
          };
        });

        // Soil-temp proxy: rolling 7-day mean of daily mean air temp.
        // Soil at 0–10 cm depth lags air temp by a few days and damps daily swings, so a 7-day
        // backward window of (tempMax+tempMin)/2 lands within a couple of °C of measured soil
        // temp in spring/fall. Only applied when the API didn't return soil data.
        var anyRealSoil = forecast.some(function (f) { return f.soilTemp != null; });
        if (!anyRealSoil) {
          for (var i = 0; i < forecast.length; i++) {
            var sum = 0, n = 0;
            for (var k = Math.max(0, i - 6); k <= i; k++) {
              if (forecast[k].tempMax != null && forecast[k].tempMin != null) {
                sum += (forecast[k].tempMax + forecast[k].tempMin) / 2;
                n++;
              }
            }
            forecast[i].soilTemp = n > 0 ? sum / n : null;
            forecast[i].soilTempEstimated = true;
          }
        }

        // Cache the result
        sessionStorage.setItem(cacheKey, JSON.stringify({ ts: Date.now(), data: forecast }));
        return { forecast: forecast, source: 'api' };
      })
      .catch(function () {
        clearTimeout(timeout);
        // Try returning stale cache if available
        if (cached) {
          try {
            var stale = JSON.parse(cached);
            return { forecast: stale.data, source: 'stale_cache', cacheAge: Date.now() - stale.ts };
          } catch (e) { /* ignore */ }
        }
        return { forecast: null, source: 'error' };
      });
  }

  /* ============================================================
     RULES ENGINE
     ============================================================ */
  function evaluateRules(forecast, blendSlug) {
    var blend = BLEND_CONFIG[blendSlug];
    if (!blend) return { status: 'go', message: '', detail: '' };

    var today = forecast[0] || {};
    var month = effectiveMonth(new Date());
    var avgSoilTemp = average(forecast.slice(0, 3).map(function (d) { return d.soilTemp; }));
    var totalPrecip48h = sum(forecast.slice(0, 2).map(function (d) { return d.precipAvg || 0; })) * 24;
    var totalPrecip7d = sum(forecast.slice(0, 7).map(function (d) { return d.precipAvg || 0; })) * 24;

    // 1. HARD BLOCKS → WAIT
    // Frost in 72h
    for (var i = 0; i < Math.min(3, forecast.length); i++) {
      if (forecast[i].tempMin < 2) {
        return result('wait',
          pick({ fr: 'Gel prévu dans les 72 heures. Attendez que les nuits soient plus douces.',
                 en: 'Frost expected within 72 hours. Wait for milder nights.' }),
          pick({ fr: 'Temp. min. prévue : ' + round(forecast[i].tempMin) + '°C (jour ' + (i + 1) + ')',
                 en: 'Min. temp. forecast: ' + round(forecast[i].tempMin) + '°C (day ' + (i + 1) + ')' }));
      }
    }
    // Hard frost in 7d
    for (var j = 0; j < Math.min(7, forecast.length); j++) {
      if (forecast[j].tempMin < 0) {
        return result('wait',
          pick({ fr: 'Risque de gel important cette semaine. Semez quand les nuits restent au-dessus de 2°C.',
                 en: 'Significant frost risk this week. Seed when nights stay above 2°C.' }),
          pick({ fr: 'Temp. min. prévue : ' + round(forecast[j].tempMin) + '°C (jour ' + (j + 1) + ')',
                 en: 'Min. temp. forecast: ' + round(forecast[j].tempMin) + '°C (day ' + (j + 1) + ')' }));
      }
    }
    // Blend-specific hard block (out of window)
    if (blend.hard_block_months.indexOf(month) !== -1) {
      var blockRule = findRule(blend.rules, 'hard_block');
      if (blockRule) {
        return result('wait', pick(blockRule), '');
      }
      return result('wait',
        pick({ fr: 'Ce mélange ne se sème pas en ce moment. Revenez vérifier à la prochaine saison.',
               en: 'This blend should not be sown right now. Check back next season.' }), '');
    }

    // 2. UNIVERSAL WAIT
    // Soil too cold
    if (avgSoilTemp !== null && avgSoilTemp < blend.soil_temp_min) {
      return result('wait',
        pick({ fr: 'Sol encore trop froid. Le gazon germe mal sous ' + blend.soil_temp_min + '°C.',
               en: 'Soil still too cold. Grass germinates poorly below ' + blend.soil_temp_min + '°C.' }),
        pick({ fr: 'Température du sol : ' + round(avgSoilTemp) + '°C — seuil minimum : ' + blend.soil_temp_min + '°C',
               en: 'Soil temperature: ' + round(avgSoilTemp) + '°C — minimum threshold: ' + blend.soil_temp_min + '°C' }));
    }
    // VIVANT stricter soil temp
    if (blendSlug === 'vivant' && avgSoilTemp !== null && avgSoilTemp < 12) {
      var vivantRule = findRule(blend.rules, 'wait');
      if (vivantRule) return result('wait', pick(vivantRule), pick({ fr: 'Température du sol : ' + round(avgSoilTemp) + '°C', en: 'Soil temperature: ' + round(avgSoilTemp) + '°C' }));
    }
    // Torrential rain — rain-tolerant blends downgrade WAIT → CAUTION
    if (totalPrecip48h > 25) {
      if (blend.rain_tolerant) {
        return result('caution',
          pick({ fr: 'Pluie abondante prévue, mais ce mélange tolère bien le sol humide. Semez quand le sol n\'est pas détrempé.',
                 en: 'Heavy rain expected, but this blend tolerates wet soil well. Seed when the ground is not waterlogged.' }),
          pick({ fr: 'Précipitations 48h : ~' + round(totalPrecip48h) + 'mm',
                 en: '48h precipitation: ~' + round(totalPrecip48h) + 'mm' }));
      }
      return result('wait',
        pick({ fr: 'Pluie abondante prévue. Les semences risquent d\'être déplacées. Attendez 48h.',
               en: 'Heavy rain expected. Seeds may be displaced. Wait 48 hours.' }),
        pick({ fr: 'Précipitations 48h : ~' + round(totalPrecip48h) + 'mm',
               en: '48h precipitation: ~' + round(totalPrecip48h) + 'mm' }));
    }

    // 3. BLEND-SPECIFIC GO BOOSTS (upgrade CAUTION → GO)
    var goBoost = null;
    blend.rules.forEach(function (rule) {
      if (rule.type !== 'go_boost') return;
      if (rule.condition === 'peak_months' && rule.months && rule.months.indexOf(month) !== -1) {
        goBoost = rule;
      }
      if (rule.condition === 'soil_warm' && avgSoilTemp !== null && avgSoilTemp >= (rule.threshold || 16)) {
        goBoost = rule;
      }
      if (rule.condition === 'dry_forecast' && totalPrecip7d < (rule.threshold || 5) * 7) {
        goBoost = rule;
      }
      if (rule.condition === 'rain_coming' && totalPrecip7d >= (rule.threshold || 5) * 7) {
        goBoost = rule;
      }
      if (rule.condition === 'cloud_cover_high' && today.cloudCover != null && today.cloudCover >= (rule.threshold || 85)) {
        goBoost = rule;
      }
    });

    // 4. UNIVERSAL CAUTION
    // Soil marginal
    if (avgSoilTemp !== null && avgSoilTemp >= blend.soil_temp_min && avgSoilTemp < 12) {
      if (goBoost) {
        return result('go', pick(goBoost),
          pick({ fr: 'Température du sol : ' + round(avgSoilTemp) + '°C', en: 'Soil temperature: ' + round(avgSoilTemp) + '°C' }));
      }
      return result('caution',
        pick({ fr: 'Sol légèrement froid — germination possible mais lente. Idéal au-dessus de 12°C.',
               en: 'Soil slightly cold — germination possible but slow. Ideal above 12°C.' }),
        pick({ fr: 'Température du sol : ' + round(avgSoilTemp) + '°C', en: 'Soil temperature: ' + round(avgSoilTemp) + '°C' }));
    }
    // Heavy rain today
    if ((today.precipAvg || 0) * 24 > 15) {
      return result('caution',
        pick({ fr: 'Sol détrempé aujourd\'hui. Semez demain si la pluie cesse.',
               en: 'Soil waterlogged today. Seed tomorrow if rain stops.' }),
        pick({ fr: 'Précipitations aujourd\'hui : ~' + round((today.precipAvg || 0) * 24) + 'mm',
               en: 'Precipitation today: ~' + round((today.precipAvg || 0) * 24) + 'mm' }));
    }
    // No rain + heat
    if (totalPrecip7d < 2 && average(forecast.slice(0, 7).map(function (d) { return d.tempMax; })) > 25) {
      return result('caution',
        pick({ fr: 'Pas de pluie prévue et chaleur. Vous devrez arroser quotidiennement pendant 2 semaines.',
               en: 'No rain forecast and heat. You will need to water daily for 2 weeks.' }),
        '');
    }
    // High winds (prairie)
    if (blendSlug === 'prairie' && (today.windMax || 0) > 25) {
      var windRule = findRule(blend.rules, 'caution', 'wind_high');
      if (windRule) {
        return result('caution', pick(windRule),
          pick({ fr: 'Vent : ' + round(today.windMax) + ' km/h', en: 'Wind: ' + round(today.windMax) + ' km/h' }));
      }
    }

    // 5. BLEND-SPECIFIC CAUTION
    // OMBRE heat stress
    if (blendSlug === 'ombre') {
      var heatDays = forecast.filter(function (d) { return d.tempMax > 30; }).length;
      if (heatDays >= 3) {
        var heatRule = findRule(blend.rules, 'caution', 'heat_streak');
        if (heatRule) return result('caution', pick(heatRule), '');
      }
    }
    // PRAIRIE late window
    if (blendSlug === 'prairie' && month >= 6) {
      var lateRule = findRule(blend.rules, 'caution', 'after_date');
      if (lateRule) return result('caution', pick(lateRule), '');
    }
    // GOLF spring off-peak
    if (blendSlug === 'golf' && (month === 5 || month === 6)) {
      var springRule = findRule(blend.rules, 'caution', 'off_peak_spring');
      if (springRule) return result('caution', pick(springRule), '');
    }

    // 6. DEFAULT → GO  (build a context-rich message that names the favorable signals)
    var goMsg;
    if (goBoost) {
      goMsg = pick(goBoost);
    } else {
      var bits = [];
      if (avgSoilTemp !== null) {
        bits.push(pick({ fr: 'sol à ' + round(avgSoilTemp) + '°C', en: 'soil at ' + round(avgSoilTemp) + '°C' }));
      }
      bits.push(pick({ fr: 'aucun gel prévu', en: 'no frost expected' }));
      if (totalPrecip7d >= 5 && totalPrecip7d <= 30) {
        bits.push(pick({ fr: 'humidité suffisante', en: 'enough moisture' }));
      } else if (totalPrecip7d < 5) {
        bits.push(pick({ fr: 'arrosage requis', en: 'watering required' }));
      }
      var lead = pick({ fr: 'Conditions favorables', en: 'Favorable conditions' });
      goMsg = lead + ' : ' + bits.join(', ') + '.';
    }
    var goDetail = '';
    if (avgSoilTemp !== null) {
      goDetail = pick({ fr: 'Température du sol : ' + round(avgSoilTemp) + '°C', en: 'Soil temperature: ' + round(avgSoilTemp) + '°C' });
    }
    return result('go', goMsg, goDetail);
  }

  /* --- Rules helpers --- */
  function result(status, message, detail) {
    return { status: status, message: message, detail: detail || '' };
  }

  function findRule(rules, type, condition) {
    for (var i = 0; i < rules.length; i++) {
      if (rules[i].type === type && (!condition || rules[i].condition === condition)) {
        return rules[i];
      }
    }
    return null;
  }

  function pick(obj) {
    return obj[LANG] || obj.fr || '';
  }

  function average(arr) {
    var valid = arr.filter(function (v) { return v != null; });
    if (!valid.length) return null;
    return valid.reduce(function (a, b) { return a + b; }, 0) / valid.length;
  }

  function sum(arr) {
    return arr.reduce(function (a, b) { return a + b; }, 0);
  }

  function round(n) {
    return n != null ? Math.round(n * 10) / 10 : '—';
  }

  /* ============================================================
     SEASONAL FALLBACK
     ============================================================ */
  function getSeasonalFallback(blendSlug) {
    var month = effectiveMonth(new Date());
    var table = SEASONAL_FALLBACK[month];
    if (!table || !table[blendSlug]) return { status: 'caution', message: '', detail: '' };
    var status = table[blendSlug];
    var perBlend = FALLBACK_MESSAGES[blendSlug] && FALLBACK_MESSAGES[blendSlug][status];
    var generic = status === 'go'
      ? { fr: 'Selon la saison, les conditions sont généralement favorables.', en: 'Based on the season, conditions are generally favorable.' }
      : status === 'caution'
        ? { fr: 'Période marginale — vérifiez à nouveau avec du signal pour une recommandation précise.', en: 'Marginal period — check again with signal for a precise recommendation.' }
        : { fr: 'Hors saison pour ce mélange.', en: 'Out of season for this blend.' };
    return {
      status: status,
      message: pick(perBlend || generic),
      detail: ''
    };
  }

  /* ============================================================
     RENDER — RESULT STATE
     ============================================================ */
  function renderResult(evaluation, forecast, source, cacheAge) {
    var blendConfig = getBlendInfo(state.blend);

    // Store evaluation status for Klaviyo and other consumers
    state.lastStatus = evaluation.status;

    // Personalization strip — "Your recommendation for [site] · [postal]"
    renderContextStrip();

    // Traffic light card
    DOM.verdict.className = 'smr-verdict smr-verdict--' + evaluation.status;
    DOM.verdictChip.textContent = blendConfig ? blendConfig.name : state.blend.toUpperCase();
    if (blendConfig) DOM.verdictChip.style.backgroundColor = blendConfig.panel_tint + '30';

    // Icon
    var iconSvg = evaluation.status === 'go'
      ? '<svg viewBox="0 0 24 24"><path d="M9 16.2l-3.5-3.5 1.4-1.4L9 13.4l7.1-7.1 1.4 1.4z"/></svg>'
      : evaluation.status === 'caution'
        ? '<svg viewBox="0 0 24 24"><path d="M12 2L1 21h22L12 2zm0 4l7.5 13h-15L12 6zm-1 5v4h2v-4h-2zm0 6v2h2v-2h-2z"/></svg>'
        : '<svg viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>';
    DOM.verdictIcon.innerHTML = iconSvg;

    // Status text
    var statusLabels = { go: UI.status_go, caution: UI.status_caution, wait: UI.status_wait };
    DOM.verdictStatus.textContent = pick(statusLabels[evaluation.status] || statusLabels.go);
    DOM.verdictMessage.textContent = evaluation.message;

    // Append blend context to detail for QR-code visitors
    var detailText = evaluation.detail || '';
    if (blendConfig) {
      var blendContext = LANG === 'en' ? blendConfig.situation_en : blendConfig.situation_fr;
      if (blendContext) {
        detailText += (detailText ? ' — ' : '') + (blendConfig.name_fr || state.blend.toUpperCase()) + ' : ' + blendContext;
      }
    }
    DOM.verdictDetail.textContent = detailText;

    // Verdict "Why" factors
    renderVerdictFactors(forecast, evaluation);

    // WAIT productive tips
    renderWaitTips(evaluation);

    // "Seed now anyway" compensating tactics + reassurance about season ahead
    renderSeedNowTips(evaluation, forecast);
    renderSeasonReassurance(evaluation, state.blend);
    renderNextSteps();

    // Best window callout
    renderBestWindow(forecast, state.blend);

    // Forecast strip
    renderForecastStrip(forecast);

    // Cache notice
    if (source === 'cache' || source === 'stale_cache') {
      var age = cacheAge || 0;
      var hours = Math.round(age / 3600000);
      DOM.cacheNotice.innerHTML = UI.cache_notice[LANG] + ' ' + (hours || '<1') + UI.cache_hours[LANG] +
        ' — <a id="smr-refresh">' + UI.cache_refresh[LANG] + '</a>';
      DOM.cacheNotice.hidden = false;
      var refreshLink = document.getElementById('smr-refresh');
      if (refreshLink) {
        refreshLink.addEventListener('click', function () {
          sessionStorage.removeItem('smr-weather-' + state.fsa);
          handleSubmit();
        });
      }
    } else {
      DOM.cacheNotice.hidden = true;
    }

    // Hide "J'ai semé" button during WAIT verdicts (contradictory UX)
    DOM.seedingCta.hidden = (evaluation.status === 'wait');

    // Product link
    if (blendConfig && blendConfig.product_url) {
      DOM.productLink.href = blendConfig.product_url;
      DOM.productLink.textContent = UI.product_link[LANG] + ' ' + (blendConfig.name || state.blend.toUpperCase()) + ' →';
      DOM.productLink.hidden = false;
    }

    // Quick-buy (inline add-to-cart)
    renderQuickBuy(blendConfig, evaluation.status);

    // Email capture for anonymous — scroll-triggered, not timer-based.
    // Gated behind CONFIG.enable_email_capture (off by default until the Klaviyo flow is live).
    // Once flows are wired up: flip the section setting on; no code change needed.
    if (!state.customerEmail && CONFIG && CONFIG.enable_email_capture) {
      var blendName = blendConfig ? (LANG === 'en' ? (blendConfig.name_en || blendConfig.name_fr) : blendConfig.name_fr) : state.blend.toUpperCase();
      // Adapt email capture messaging based on verdict
      if (evaluation.status === 'wait') {
        DOM.captureHeadline.textContent = pick({
          fr: 'Recevez une alerte quand les conditions seront idéales pour ' + blendName + '.',
          en: 'Get an alert when conditions are ideal for ' + blendName + '.'
        });
        DOM.captureSubline.textContent = pick({
          fr: 'Entrez votre courriel — on vous prévient à la bonne saison.',
          en: 'Enter your email — we\'ll notify you at the right season.'
        });
      } else if (evaluation.status === 'caution') {
        DOM.captureHeadline.textContent = pick({
          fr: 'Recevez un rappel quand les conditions s\'amélioreront pour ' + blendName + '.',
          en: 'Get a reminder when conditions improve for ' + blendName + '.'
        });
        DOM.captureSubline.textContent = UI.capture_subline[LANG];
      } else {
        DOM.captureHeadline.textContent = pick({
          fr: 'Recevez votre guide de germination pour ' + blendName + ' par courriel.',
          en: 'Get your germination guide for ' + blendName + ' by email.'
        });
        DOM.captureSubline.textContent = UI.capture_subline[LANG];
      }
      DOM.captureSubmit.textContent = UI.capture_submit[LANG];
      DOM.accountLink.innerHTML = '<a href="/account/register?return_url=/pages/semer?blend=' + state.blend + '">' + UI.capture_account[LANG] + '</a>';

      // Use IntersectionObserver to show capture when actions area enters viewport
      if ('IntersectionObserver' in window) {
        var actionsEl = DOM.seedingCta.parentElement;
        var captureObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              DOM.capture.hidden = false;
              DOM.capture.classList.add('smr-capture--visible');
              // Auto-focus email on desktop only (avoid mobile keyboard popup)
              if (window.innerWidth >= 768) {
                DOM.captureEmail.focus();
              }
              captureObserver.disconnect();
            }
          });
        }, { threshold: 0.3 });
        captureObserver.observe(actionsEl);
      } else {
        // Fallback for older browsers
        setTimeout(function () {
          DOM.capture.hidden = false;
          DOM.capture.classList.add('smr-capture--visible');
        }, 800);
      }
    }

    // Haptic feedback for GO verdict (Android)
    if (evaluation.status === 'go' && navigator.vibrate) {
      navigator.vibrate(50);
    }

    // Unlock share in result state (not just after survey)
    if (window.__SEMER_TOOLS_HOOKS && window.__SEMER_TOOLS_HOOKS.showShare) {
      window.__SEMER_TOOLS_HOOKS.showShare(evaluation.status);
    }

    // Klaviyo "Recommendation Viewed" event
    var bestWindowDay = null;
    if (forecast && forecast.length > 0) {
      for (var bw = 0; bw < forecast.length; bw++) {
        if (forecast[bw].status === 'go') { bestWindowDay = bw; break; }
      }
    }
    pushKlaviyoEvent('TERRAIN Recommendation Viewed', {
      blend: state.blend,
      status: evaluation.status,
      postal_code: state.postalCode,
      source: source,
      best_window_day: bestWindowDay
    });

  }

  function renderFallbackResult(fallback) {
    renderResult(fallback, [], 'fallback');
    DOM.verdict.classList.add('smr-verdict--fallback');
    DOM.cacheNotice.textContent = UI.fallback_notice[LANG];
    DOM.cacheNotice.hidden = false;
    // Hide forecast strip for fallback
    DOM.forecast.innerHTML = '';
    DOM.forecastLabel.hidden = true;
  }

  /* ============================================================
     RENDER — VERDICT FACTORS ("WHY?")
     ============================================================ */
  var FACTOR_ICONS = {
    soil: '<svg viewBox="0 0 20 20" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M10 2v16M6 6c0-2 2-3 4-3s4 1 4 3M5 14h10"/></svg>',
    frost: '<svg viewBox="0 0 20 20" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M10 2v16M2 10h16M4 4l12 12M16 4L4 16"/></svg>',
    precip: '<svg viewBox="0 0 20 20" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 9a4 4 0 00-8 0 3 3 0 000 6h8a3 3 0 000-6zM7 17v1M10 16v2M13 17v1"/></svg>',
    wind: '<svg viewBox="0 0 20 20" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 7h10a2 2 0 100-4M3 11h12a2 2 0 110 4M3 15h6a2 2 0 100-4"/></svg>'
  };

  function renderVerdictFactors(forecast, evaluation) {
    if (!DOM.verdictFactors || !DOM.factorsGrid || !forecast || forecast.length === 0) {
      if (DOM.verdictFactors) DOM.verdictFactors.hidden = true;
      return;
    }

    DOM.factorsToggle.textContent = pick(UI.factors_toggle);
    DOM.factorsGrid.innerHTML = '';

    var day0 = forecast[0] || {};
    var blendCfg = BLEND_CONFIG[state.blend] || {};

    // Factor 1: Soil temperature (real on Pro tier; 7-day air-temp running avg as proxy on Free tier)
    var soilTemp = day0.soilTemp != null ? Math.round(day0.soilTemp * 10) / 10 : null;
    var soilIdealMin = blendCfg.soil_temp_min || 8;
    var soilIdealMax = 18;
    var soilStatus = soilTemp == null ? 'caution' : (soilTemp >= soilIdealMin && soilTemp <= soilIdealMax ? 'go' : soilTemp < soilIdealMin ? 'wait' : 'caution');
    var soilLabel = pick(UI.factor_soil_temp);
    if (day0.soilTempEstimated) {
      soilLabel += ' ' + pick({ fr: '(estimé)', en: '(estimated)' });
    }
    var soilValue = soilTemp != null ? soilTemp + '°C' : '—';
    var soilRange = soilIdealMin + '–' + soilIdealMax + '°C';
    addFactor(FACTOR_ICONS.soil, soilLabel, soilValue, soilRange, soilStatus);

    // Factor 2: Frost risk
    var frostDay = null;
    for (var i = 0; i < Math.min(forecast.length, 10); i++) {
      if (forecast[i].tempMin != null && forecast[i].tempMin < 0) {
        frostDay = i;
        break;
      }
    }
    var frostStatus = frostDay === null ? 'go' : (frostDay <= 2 ? 'wait' : 'caution');
    var frostValue = frostDay === null ? pick(UI.factor_no_frost) : pick(UI.factor_frost_day).replace('{N}', frostDay + 1);
    addFactor(FACTOR_ICONS.frost, pick(UI.factor_frost), frostValue, '', frostStatus);

    // Factor 3: Precipitation (7-day total)
    var precipTotal = 0;
    for (var j = 0; j < Math.min(forecast.length, 7); j++) {
      precipTotal += (forecast[j].precipAvg || 0) * 24;
    }
    precipTotal = Math.round(precipTotal);
    var precipStatus = precipTotal < 10 ? 'go' : precipTotal < 30 ? 'caution' : 'wait';
    var precipLabel = precipTotal < 10 ? pick(UI.factor_precip_low) : precipTotal < 30 ? pick(UI.factor_precip_mod) : pick(UI.factor_precip_high);
    addFactor(FACTOR_ICONS.precip, pick(UI.factor_precip), precipTotal + ' mm', precipLabel, precipStatus);

    // Factor 4: Wind (48h max)
    var windMax = 0;
    for (var k = 0; k < Math.min(forecast.length, 2); k++) {
      if (forecast[k].windMax != null && forecast[k].windMax > windMax) windMax = forecast[k].windMax;
    }
    windMax = Math.round(windMax);
    var windStatus = windMax < 20 ? 'go' : windMax < 35 ? 'caution' : 'wait';
    var windLabel = windMax + ' km/h';
    addFactor(FACTOR_ICONS.wind, pick(UI.factor_wind), windLabel, '', windStatus);

    // Always open by default — the "why" is the most asked question. Mobile users can collapse if needed.
    DOM.verdictFactors.setAttribute('open', '');
    DOM.verdictFactors.hidden = false;
  }

  function addFactor(icon, label, value, sublabel, status) {
    var statusLabel = status === 'go' ? pick(UI.factor_good) : status === 'caution' ? pick(UI.factor_caution) : pick(UI.factor_bad);
    var el = document.createElement('div');
    el.className = 'smr-factor smr-factor--' + status;
    el.innerHTML = '<div class="smr-factor__icon">' + icon + '</div>'
      + '<div class="smr-factor__body">'
      + '<span class="smr-factor__label">' + label + '</span>'
      + '<span class="smr-factor__value">' + value + '</span>'
      + (sublabel ? '<span class="smr-factor__sub">' + sublabel + '</span>' : '')
      + '<span class="smr-factor__status">' + statusLabel + '</span>'
      + '</div>';
    DOM.factorsGrid.appendChild(el);
  }

  /* ============================================================
     RENDER — WAIT PRODUCTIVE TIPS
     ============================================================ */
  function renderWaitTips(evaluation) {
    if (!DOM.waitTips) return;
    if (evaluation.status !== 'wait') {
      DOM.waitTips.hidden = true;
      return;
    }
    var tips = pick(UI.wait_tips);
    if (state.customerEmail) {
      tips += ' ' + pick(UI.wait_notify);
    }
    DOM.waitTips.textContent = tips;
    DOM.waitTips.hidden = false;
  }

  /* ============================================================
     RENDER — "SEED TODAY ANYWAY" TIPS
     Picks 2–3 tips relevant to the current forecast and verdict so customers who want to
     seed in marginal conditions know what to do. Always shows on CAUTION + WAIT (and a light
     "best practices" version on GO so it's never empty). Never discourages — frames as
     "here's how to make it work today".
     ============================================================ */
  function renderSeedNowTips(evaluation, forecast) {
    if (!DOM.seedNow || !DOM.seedNowList) return;
    var status = evaluation && evaluation.status;
    if (!status) { DOM.seedNow.hidden = true; return; }

    var blendCfg = BLEND_CONFIG[state.blend] || {};
    var tipKeys = pickRelevantTips(evaluation, forecast || [], blendCfg);
    if (!tipKeys.length) { DOM.seedNow.hidden = true; return; }

    var heading = status === 'wait' ? UI.seed_now_heading_wait
                : status === 'caution' ? UI.seed_now_heading_caution
                : UI.seed_now_heading_go;
    if (DOM.seedNowHeading) DOM.seedNowHeading.textContent = pick(heading);

    DOM.seedNowList.innerHTML = '';
    tipKeys.forEach(function (k) {
      var tip = SEED_NOW_TIPS[k] && SEED_NOW_TIPS[k][LANG];
      if (!tip) return;
      var el = document.createElement('li');
      el.className = 'smr-seed-now__item';
      el.innerHTML = '<strong class="smr-seed-now__title">' + tip.title + '</strong>'
                   + '<span class="smr-seed-now__body">' + tip.body + '</span>';
      DOM.seedNowList.appendChild(el);
    });
    DOM.seedNow.hidden = false;
  }

  function pickRelevantTips(evaluation, forecast, blendCfg) {
    var keys = [];
    var today = forecast[0] || {};
    var avgSoilTemp = forecast.length ? average(forecast.slice(0, 3).map(function (d) { return d.soilTemp; })) : null;
    var totalPrecip48h = forecast.length ? sum(forecast.slice(0, 2).map(function (d) { return d.precipAvg || 0; })) * 24 : null;
    var totalPrecip7d = forecast.length ? sum(forecast.slice(0, 7).map(function (d) { return d.precipAvg || 0; })) * 24 : null;
    var avgMaxTemp = forecast.length ? average(forecast.slice(0, 7).map(function (d) { return d.tempMax; })) : null;
    var maxWind = forecast.length ? Math.max.apply(null, forecast.slice(0, 2).map(function (d) { return d.windMax || 0; })) : 0;
    var hasFrostSoon = false;
    for (var i = 0; i < Math.min(forecast.length, 5); i++) {
      if (forecast[i].tempMin != null && forecast[i].tempMin < 2) { hasFrostSoon = true; break; }
    }
    var month = effectiveMonth(new Date());
    var inHardBlock = blendCfg.hard_block_months && blendCfg.hard_block_months.indexOf(month) !== -1;
    var soilFloor = blendCfg.soil_temp_min || 8;

    // Order matters — most-impactful tip first.
    if (avgSoilTemp != null && avgSoilTemp < soilFloor) keys.push('cold_soil');
    if (hasFrostSoon) keys.push('frost_risk');
    if (totalPrecip48h != null && totalPrecip48h > 25) keys.push('heavy_rain');
    else if (today.precipAvg != null && today.precipAvg * 24 > 15) keys.push('waterlogged');
    if (totalPrecip7d != null && totalPrecip7d < 5 && avgMaxTemp != null && avgMaxTemp > 22) keys.push('dry_heat');
    if (maxWind > 25 && state.blend === 'prairie') keys.push('wind');
    if (inHardBlock) keys.push('off_season');
    // Always end with best-practice tip if we have room (caps at 3)
    if (keys.length < 3) keys.push('best_practice');
    return keys.slice(0, 3);
  }

  /* ============================================================
     RENDER — SEASON-AHEAD REASSURANCE
     Tells the customer how much of the seeding season is still ahead so they don't feel
     time-pressured into bad conditions. Shown on WAIT + CAUTION; hidden on GO (no need to
     reassure when it's already a green light).
     ============================================================ */
  function renderSeasonReassurance(evaluation, blendSlug) {
    if (!DOM.reassure) return;
    if (!evaluation || evaluation.status === 'go') { DOM.reassure.hidden = true; return; }

    var blendCfg = BLEND_CONFIG[blendSlug] || {};
    var goMonths = blendCfg.season_go || [];
    if (!goMonths.length) { DOM.reassure.hidden = true; return; }

    // Whether the blend HAS a spring/fall window is decided by season_go (the optimal months).
    // The customer-facing END dates use the broader PRACTICAL window (season_go ∪ season_caution
    // minus hard-block months) — sowing remains feasible during caution months, and we want to
    // counteract false urgency, not invent it.
    var hardBlock = blendCfg.hard_block_months || [];
    var practical = goMonths.concat(blendCfg.season_caution || [])
      .filter(function (m) { return hardBlock.indexOf(m) === -1; });

    var hasSpring = goMonths.some(function (m) { return m <= 6; });
    var hasFall   = goMonths.some(function (m) { return m >= 8; });

    // Cap spring at June (6) and fall start at August (8). July is summer-heat dead zone for
    // cool-season grass — including it in either window creates overlapping/confusing copy.
    var springPractical = practical.filter(function (m) { return m <= 6; });
    var fallPractical   = practical.filter(function (m) { return m >= 8; });

    // Cold-spring offset: only the SPRING window shifts (it's the spring that's running late).
    // The fall window opens on its normal schedule — by August/September the season has caught
    // up. So we only apply the offset when computing spring dates.
    var springOffsetDays = seasonOffsetWeeks() * 7;

    function lastOfMonth(monthNum, applyOffset) {
      var d = new Date(new Date().getFullYear(), monthNum, 0); // last day of monthNum
      if (applyOffset) d.setDate(d.getDate() + springOffsetDays);
      return d;
    }
    function firstOfMonth(monthNum, applyOffset) {
      var d = new Date(new Date().getFullYear(), monthNum - 1, 1);
      if (applyOffset) d.setDate(d.getDate() + springOffsetDays);
      return d;
    }
    function softDateLabel(d) {
      var monthLabels = LANG === 'en'
        ? ['January','February','March','April','May','June','July','August','September','October','November','December']
        : ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
      var day = d.getDate();
      var lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
      var name = monthLabels[d.getMonth()];
      // Round to nearest fortnight: début (≤10), mi (11–20), fin (21+).
      // EN: "early", "mid-", "late".
      var prefix;
      if (day <= 10) prefix = LANG === 'en' ? 'early ' : 'début ';
      else if (day <= 20) prefix = LANG === 'en' ? 'mid-' : 'mi-';
      else prefix = LANG === 'en' ? 'late ' : 'fin ';
      return prefix + name;
    }

    var body = '';
    if (hasSpring && hasFall) {
      var springEndLabel = softDateLabel(lastOfMonth(Math.max.apply(null, springPractical), true));
      if (fallPractical.length === 1) {
        body = pick(UI.season_reassure_both_single_fall)
          .replace('{SPRING}', springEndLabel)
          .replace('{FALL}', softDateLabel(firstOfMonth(fallPractical[0], false)).replace(/^(early |mid-|late |début |mi-|fin )/, ''));
      } else {
        body = pick(UI.season_reassure_both)
          .replace('{SPRING}', springEndLabel)
          .replace('{FALL_START}', softDateLabel(firstOfMonth(Math.min.apply(null, fallPractical), false)))
          .replace('{FALL_END}', softDateLabel(lastOfMonth(Math.max.apply(null, fallPractical), false)));
      }
    } else if (hasSpring) {
      body = pick(UI.season_reassure_spring).replace('{DATE}',
        softDateLabel(lastOfMonth(Math.max.apply(null, springPractical), true)));
    } else if (hasFall) {
      body = pick(UI.season_reassure_fall).replace('{DATE}',
        softDateLabel(firstOfMonth(Math.min.apply(null, fallPractical), false)));
    }

    if (!body) { DOM.reassure.hidden = true; return; }

    if (DOM.reassureTitle) DOM.reassureTitle.textContent = pick(UI.season_reassure_title);
    if (DOM.reassureBody)  DOM.reassureBody.textContent  = body;
    DOM.reassure.hidden = false;
  }

  /* ============================================================
     RENDER — "WHAT'S NEXT" LINKS
     Keeps customers in the funnel after every verdict — collection link drives browsing,
     copy-link gives a no-email way to come back later.
     ============================================================ */
  function renderNextSteps() {
    if (!DOM.next || !DOM.nextHeading || !DOM.nextCollection || !DOM.nextCopy) return;

    DOM.nextHeading.textContent = pick(UI.next_steps_heading);
    DOM.nextCollection.textContent = pick(UI.next_collection);
    DOM.nextCollection.href = (CONFIG && CONFIG.next_collection_url) || '/collections/all';

    DOM.nextCopy.textContent = pick(UI.next_copy_link);

    // Replace any prior listener so consecutive verdicts don't stack handlers
    var fresh = DOM.nextCopy.cloneNode(true);
    DOM.nextCopy.parentNode.replaceChild(fresh, DOM.nextCopy);
    DOM.nextCopy = fresh;
    DOM.nextCopy.addEventListener('click', function () {
      var url = window.location.origin + window.location.pathname + '?blend=' + encodeURIComponent(state.blend) + '&postal=' + encodeURIComponent(state.postalCode || '');
      var flashDone = function () {
        DOM.nextCopy.textContent = pick(UI.next_copy_done);
        DOM.nextCopy.classList.add('smr-next__link--done');
        setTimeout(function () {
          DOM.nextCopy.textContent = pick(UI.next_copy_link);
          DOM.nextCopy.classList.remove('smr-next__link--done');
        }, 2200);
      };
      // Try clipboard API first; if it rejects (permissions policy, non-secure context),
      // fall back to the textarea+execCommand trick. Either way, show feedback.
      var didCopy = false;
      var attempt = navigator.clipboard && navigator.clipboard.writeText
        ? navigator.clipboard.writeText(url).then(function () { didCopy = true; }, function () {})
        : Promise.resolve();
      attempt.then(function () {
        if (!didCopy) {
          var ta = document.createElement('textarea');
          ta.value = url;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); didCopy = true; } catch (e) { /* silent */ }
          document.body.removeChild(ta);
        }
        // Always flash feedback — better UX than silence even if both copy paths failed.
        flashDone();
      });
    });

    DOM.next.hidden = false;
  }

  /* ============================================================
     RENDER — PERSONALIZATION CONTEXT STRIP
     Sits above the verdict card on the result page. Shows what the customer told us
     (site name + postal) so the page reads as personalised, not generic.
     ============================================================ */
  function renderContextStrip() {
    if (!DOM.context || !DOM.contextLabel) return;
    var hasSite = !!(state.siteName && state.siteName.length);
    var hasPostal = !!state.postalCode;
    if (!hasSite && !hasPostal) { DOM.context.hidden = true; return; }

    DOM.contextLabel.textContent = pick(UI.context_label);
    DOM.contextSite.textContent = hasSite ? state.siteName : '';
    DOM.contextSite.hidden = !hasSite;
    // Canadian postal codes display as "FSA LDU" (e.g., "J0E 2P0"). We store the compact form
    // internally; format for display only.
    var prettyPostal = '';
    if (hasPostal) {
      prettyPostal = state.postalCode.length === 6
        ? state.postalCode.slice(0, 3) + ' ' + state.postalCode.slice(3)
        : state.postalCode;
    }
    DOM.contextPostal.textContent = prettyPostal;
    DOM.contextPostal.hidden = !hasPostal;
    DOM.contextSep.hidden = !(hasSite && hasPostal);
    DOM.context.hidden = false;
  }

  /* ============================================================
     RENDER — QUICK BUY (INLINE ADD-TO-CART)
     ============================================================ */
  var quickBuyState = { variantId: null, price: null };

  function renderQuickBuy(blendConfig, verdictStatus) {
    if (!DOM.quickBuy || !blendConfig) return;
    // We deliberately surface quick-buy on every status — including WAIT — but reframe the
    // headline so customers understand they're stocking up to seed at the right moment.

    // Build size options from config data
    var sizes = [];
    if (blendConfig.variant_1_5kg) sizes.push({ label: '1,5 kg', variant: blendConfig.variant_1_5kg, price: blendConfig.price_1_5kg, weight: 1.5 });
    if (blendConfig.variant_5kg) sizes.push({ label: '5 kg', variant: blendConfig.variant_5kg, price: blendConfig.price_5kg, weight: 5 });
    if (blendConfig.variant_25kg) sizes.push({ label: '25 kg', variant: blendConfig.variant_25kg, price: blendConfig.price_25kg, weight: 25 });

    if (sizes.length === 0) {
      DOM.quickBuy.hidden = true;
      return;
    }

    // Label — different framing on WAIT (positioning the purchase as preparation)
    DOM.quickBuyLabel.textContent = pick(verdictStatus === 'wait' ? UI.quick_buy_label_wait : UI.quick_buy_label);

    // Build size buttons
    DOM.quickBuySizes.innerHTML = '';
    var coverageRate = BLEND_CONFIG[state.blend] ? BLEND_CONFIG[state.blend].coverage_new : null;

    sizes.forEach(function (size, index) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'smr-quick-buy__size';
      var priceText = size.price ? ('$' + Number(size.price).toFixed(2)) : '';

      // Coverage hint
      var coverageText = '';
      if (coverageRate && size.weight) {
        var sqm = Math.round((size.weight * 1000) / coverageRate);
        coverageText = ' · ≈ ' + sqm + ' m²';
      }

      btn.innerHTML = '<span class="smr-quick-buy__size-label">' + size.label + '</span>'
        + '<span class="smr-quick-buy__size-price">' + priceText + '</span>'
        + (coverageText ? '<span class="smr-quick-buy__size-coverage">' + coverageText + '</span>' : '');

      btn.addEventListener('click', function () {
        selectQuickBuySize(size.variant, size.price, btn);
      });

      DOM.quickBuySizes.appendChild(btn);

      // Default select middle size, or first if only one
      var defaultIndex = sizes.length > 1 ? 1 : 0;
      if (index === defaultIndex) {
        selectQuickBuySize(size.variant, size.price, btn);
      }
    });

    // Note
    DOM.quickBuyNote.textContent = pick(UI.quick_buy_note);

    // PDP link
    if (blendConfig.product_url) {
      DOM.quickBuyPdp.href = blendConfig.product_url;
      DOM.quickBuyPdp.textContent = pick(UI.quick_buy_pdp);
      DOM.quickBuyPdp.hidden = false;
    } else {
      DOM.quickBuyPdp.hidden = true;
    }

    // ATC button event (remove old listener by replacing)
    var newAtc = DOM.quickBuyAtc.cloneNode(true);
    DOM.quickBuyAtc.parentNode.replaceChild(newAtc, DOM.quickBuyAtc);
    DOM.quickBuyAtc = newAtc;
    DOM.quickBuyAtc.addEventListener('click', function () {
      if (quickBuyState.variantId) handleAddToCart(quickBuyState.variantId);
    });

    DOM.quickBuy.hidden = false;
  }

  function selectQuickBuySize(variantId, price, btn) {
    quickBuyState.variantId = variantId;
    quickBuyState.price = price;

    // Update selected state
    var allBtns = DOM.quickBuySizes.querySelectorAll('.smr-quick-buy__size');
    allBtns.forEach(function (b) { b.classList.remove('smr-quick-buy__size--selected'); });
    btn.classList.add('smr-quick-buy__size--selected');

    // Update ATC button text
    var priceText = price ? ('$' + Number(price).toFixed(2)) : '';
    DOM.quickBuyAtc.textContent = pick(UI.quick_buy_atc).replace('{PRICE}', priceText);
    DOM.quickBuyAtc.disabled = false;
  }

  function handleAddToCart(variantId) {
    DOM.quickBuyAtc.disabled = true;
    DOM.quickBuyAtc.textContent = '...';

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/javascript' }
    })
    .then(function (response) {
      if (!response.ok) throw new Error('Cart error');
      return response.json();
    })
    .then(function () {
      // Success state
      DOM.quickBuyAtc.textContent = pick(UI.quick_buy_added);
      DOM.quickBuyAtc.classList.add('smr-quick-buy__atc--success');
      // Update cart count in header if it exists
      var cartCount = document.querySelector('.cart-count-bubble, [data-cart-count]');
      if (cartCount) {
        var current = parseInt(cartCount.textContent) || 0;
        cartCount.textContent = current + 1;
      }
      // Re-enable after 3 seconds
      setTimeout(function () {
        var priceText = quickBuyState.price ? ('$' + Number(quickBuyState.price).toFixed(2)) : '';
        DOM.quickBuyAtc.textContent = pick(UI.quick_buy_atc).replace('{PRICE}', priceText);
        DOM.quickBuyAtc.classList.remove('smr-quick-buy__atc--success');
        DOM.quickBuyAtc.disabled = false;
      }, 3000);
    })
    .catch(function () {
      // Error state
      DOM.quickBuyAtc.textContent = pick(UI.quick_buy_error);
      DOM.quickBuyAtc.classList.add('smr-quick-buy__atc--error');
      setTimeout(function () {
        var priceText = quickBuyState.price ? ('$' + Number(quickBuyState.price).toFixed(2)) : '';
        DOM.quickBuyAtc.textContent = pick(UI.quick_buy_atc).replace('{PRICE}', priceText);
        DOM.quickBuyAtc.classList.remove('smr-quick-buy__atc--error');
        DOM.quickBuyAtc.disabled = false;
      }, 2000);
    });
  }

  /* ============================================================
     RENDER — BEST WINDOW CALLOUT
     ============================================================ */
  function renderBestWindow(forecast, blendSlug) {
    if (!forecast || forecast.length < 3) {
      DOM.window.hidden = true;
      return;
    }

    var blend = BLEND_CONFIG[blendSlug];
    if (!blend) { DOM.window.hidden = true; return; }

    // Check today's status
    var todayEval = evaluateRules(forecast, blendSlug);

    if (todayEval.status === 'go') {
      // Count consecutive GO days
      var goDays = 0;
      for (var i = 0; i < forecast.length; i++) {
        var dayEval = evaluateRules(forecast.slice(i), blendSlug);
        if (dayEval.status === 'go') goDays++;
        else break;
      }
      DOM.window.innerHTML = '<strong>' + UI.window_today[LANG].replace('{X}', goDays) + '</strong>';
      DOM.window.hidden = false;
    } else {
      // Find first GO window in next 10 days
      var goStart = -1;
      for (var k = 1; k < forecast.length; k++) {
        var futureEval = evaluateRules(forecast.slice(k), blendSlug);
        if (futureEval.status === 'go') { goStart = k; break; }
      }
      if (goStart > 0) {
        var dateStr = formatDate(forecast[goStart].date);
        DOM.window.innerHTML = '<strong>' + UI.window_future[LANG].replace('{DATE}', dateStr).replace('{X}', goStart) + '</strong>';
        DOM.window.hidden = false;
      } else {
        DOM.window.innerHTML = UI.window_none[LANG];
        DOM.window.hidden = false;
      }
    }
  }

  /* ============================================================
     RENDER — 10-DAY FORECAST STRIP
     ============================================================ */
  function renderForecastStrip(forecast) {
    if (!forecast || !forecast.length) {
      DOM.forecast.innerHTML = '';
      return;
    }

    var html = '';
    var dayNames = UI.day_names[LANG];
    var todayStr = new Date().toISOString().slice(0, 10);

    forecast.forEach(function (day, i) {
      var d = new Date(day.date + 'T12:00:00');
      var dayName = dayNames[d.getDay()];
      var dateLabel = d.getDate() + '/' + (d.getMonth() + 1);
      var isToday = day.date === todayStr;
      var icon = weatherCodeToIcon(day.weatherCode);

      // Evaluate this day's seeding status
      var dayStatus = 'go';
      if (day.tempMin < 2 || (day.soilTemp != null && day.soilTemp < 8)) dayStatus = 'wait';
      else if ((day.precipAvg || 0) * 24 > 15 || (day.tempMin >= 2 && day.tempMin < 5)) dayStatus = 'caution';

      // Accessible status labels
      var statusLabels = { go: { fr: 'favorable', en: 'favorable' }, caution: { fr: 'prudence', en: 'caution' }, wait: { fr: 'pas idéal', en: 'not ideal' } };
      var dotLabel = pick(statusLabels[dayStatus]);
      // Full day aria-label
      var weatherLabels = { sunny: { fr: 'ensoleillé', en: 'sunny' }, cloudy: { fr: 'nuageux', en: 'cloudy' }, rain: { fr: 'pluvieux', en: 'rainy' }, snow: { fr: 'neigeux', en: 'snowy' } };
      var weatherWord = '';
      if (!day.weatherCode || day.weatherCode <= 1001) weatherWord = pick(weatherLabels.sunny);
      else if (day.weatherCode >= 5000) weatherWord = pick(weatherLabels.snow);
      else if (day.weatherCode >= 4000) weatherWord = pick(weatherLabels.rain);
      else weatherWord = pick(weatherLabels.cloudy);
      var dayAriaLabel = dayName + ' ' + dateLabel + ': max ' + round(day.tempMax) + '°, min ' + round(day.tempMin) + '°, ' + weatherWord + ', ' + dotLabel;

      html += '<div class="smr-forecast__day' + (isToday ? ' smr-forecast__day--today' : '') + '" role="listitem" aria-label="' + dayAriaLabel + '">'
        + '<div class="smr-forecast__dayname">' + dayName + '</div>'
        + '<div class="smr-forecast__date">' + dateLabel + '</div>'
        + '<div class="smr-forecast__icon">' + icon + '</div>'
        + '<div class="smr-forecast__temps">' + round(day.tempMax) + '° <span>' + round(day.tempMin) + '°</span></div>'
        + '<div class="smr-forecast__dot smr-forecast__dot--' + dayStatus + '" aria-label="' + dotLabel + '"></div>'
        + '</div>';
    });

    DOM.forecast.innerHTML = html;
    DOM.forecast.setAttribute('role', 'list');
    // Update label with the actual interval count returned by the API (5 on Free tier, 10 on Pro)
    DOM.forecastLabel.textContent = pick(UI.forecast_label).replace('{N}', forecast.length);
    DOM.forecastLabel.hidden = false;

    // Scroll affordance: fade indicator on right edge for mobile
    initForecastScrollHint();
  }

  function initForecastScrollHint() {
    if (!DOM.forecast) return;
    var scrolled = false;
    DOM.forecast.classList.add('smr-forecast--has-overflow');

    DOM.forecast.addEventListener('scroll', function () {
      if (!scrolled) {
        scrolled = true;
        DOM.forecast.classList.remove('smr-forecast--has-overflow');
      }
      // Show/hide left fade
      DOM.forecast.classList.toggle('smr-forecast--scrolled-left', DOM.forecast.scrollLeft > 20);
    }, { passive: true });
  }

  /* ============================================================
     EMAIL CAPTURE
     ============================================================ */
  function handleEmailCapture() {
    var email = DOM.captureEmail.value.trim();
    if (!email || !DOM.caslCheck.checked) return;

    // Validate email format
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      DOM.captureEmail.style.borderColor = 'var(--c-red)';
      return;
    }
    DOM.captureEmail.style.borderColor = '';

    // Push to Klaviyo
    pushKlaviyoIdentify(email);

    // Visual confirmation
    DOM.capture.innerHTML = '<p class="smr-capture__headline" style="color:var(--smr-go);">'
      + pick({ fr: '✓ Vous recevrez vos rappels de semis.', en: '✓ You will receive your seeding reminders.' })
      + '</p>';

    state.customerEmail = email;
  }

  /* ============================================================
     SEEDING CONFIRMATION
     ============================================================ */
  function handleSeedingConfirmation() {
    // Check for existing active seeding record (overwrite guard)
    var existingRecord = safeStorageGet('smr-seeding-record');
    if (existingRecord && DOM.seedingGuard) {
      try {
        var existing = JSON.parse(existingRecord);
        if (existing.date && existing.blend) {
          var daysSince = Math.floor((Date.now() - new Date(existing.date).getTime()) / 86400000);
          if (daysSince >= 0 && daysSince <= 45) {
            // Show overwrite guard
            var blendInfo = getBlendInfo(existing.blend);
            var blendName = blendInfo ? (LANG === 'en' ? (blendInfo.name_en || blendInfo.name_fr) : blendInfo.name_fr) : existing.blend.toUpperCase();
            DOM.seedingGuardText.textContent = pick(UI.guard_text).replace('{BLEND}', blendName).replace('{DAYS}', daysSince);
            DOM.seedingGuardReplace.textContent = pick(UI.guard_replace);
            DOM.seedingGuardCancel.textContent = pick(UI.guard_cancel);

            DOM.seedingGuard.hidden = false;
            DOM.seedingCta.hidden = true;

            // Handle replace
            DOM.seedingGuardReplace.onclick = function () {
              DOM.seedingGuard.hidden = true;
              // Clear old germination tracking
              safeStorageSet('smr-germination-confirmed', '');
              safeStorageSet('smr-survey-done', '');
              performSeedingConfirmation();
            };

            // Handle cancel
            DOM.seedingGuardCancel.onclick = function () {
              DOM.seedingGuard.hidden = true;
              DOM.seedingCta.hidden = false;
            };

            return; // Wait for user decision
          }
        }
      } catch (e) { /* proceed if corrupt */ }
    }

    performSeedingConfirmation();
  }

  function performSeedingConfirmation() {
    var seedingData = {
      date: new Date().toISOString().slice(0, 10),
      blend: state.blend,
      postalCode: state.postalCode,
      fsa: state.fsa,
      soilTemp: state.forecast && state.forecast[0] ? state.forecast[0].soilTemp : null,
      airTempMax: state.forecast && state.forecast[0] ? state.forecast[0].tempMax : null,
      precipOutlook: getPrecipOutlook(),
      status: state.lastStatus ? state.lastStatus.toUpperCase() : 'UNKNOWN',
      germinationMin: BLEND_CONFIG[state.blend] ? BLEND_CONFIG[state.blend].germination[0] : 7,
      germinationMax: BLEND_CONFIG[state.blend] ? BLEND_CONFIG[state.blend].germination[1] : 14
    };

    // Save to localStorage
    safeStorageSet('smr-seeding-record', JSON.stringify(seedingData));

    // Push to Klaviyo if email available
    if (state.customerEmail) {
      pushKlaviyoSeeding(state.customerEmail, seedingData);
    } else {
      // Show email capture
      DOM.capture.hidden = false;
      DOM.captureHeadline.textContent = pick({
        fr: 'Entrez votre courriel pour recevoir le suivi de germination.',
        en: 'Enter your email to receive germination tracking.'
      });
    }

    // Replace button with confirmation
    DOM.seedingCta.textContent = pick({ fr: '✓ Semis enregistré', en: '✓ Seeding recorded' });
    DOM.seedingCta.disabled = true;
    DOM.seedingCta.hidden = false;
    DOM.seedingCta.style.background = 'var(--smr-go)';
  }

  function getPrecipOutlook() {
    if (!state.forecast) return 'unknown';
    var total = sum(state.forecast.slice(0, 7).map(function (d) { return (d.precipAvg || 0) * 24; }));
    if (total < 10) return 'low';
    if (total < 30) return 'moderate';
    return 'high';
  }

  /* ============================================================
     KLAVIYO INTEGRATION
     ============================================================ */
  function pushKlaviyoEvent(eventName, data) {
    var _learnq = window._learnq || [];
    _learnq.push(['track', eventName, data]);
  }

  function pushKlaviyoIdentify(email) {
    var _learnq = window._learnq || [];
    _learnq.push(['identify', {
      '$email': email,
      'terrain_language': LANG,
      'terrain_last_blend': state.blend,
      'terrain_last_postal_code': state.postalCode
    }]);
  }

  function pushKlaviyoSeeding(email, data) {
    var _learnq = window._learnq || [];
    _learnq.push(['identify', {
      '$email': email,
      'terrain_last_seeding_date': data.date,
      'terrain_last_blend': data.blend,
      'terrain_last_postal_code': data.postalCode,
      'terrain_last_soil_temp_c': data.soilTemp,
      'terrain_last_air_temp_max_c': data.airTempMax,
      'terrain_precip_outlook': data.precipOutlook,
      'terrain_rec_status': data.status,
      'terrain_germination_confirmed': false,
      'terrain_language': LANG
    }]);
    _learnq.push(['track', 'TERRAIN Seeding Recorded', {
      'blend': data.blend,
      'date': data.date,
      'postal_code': data.postalCode,
      'soil_temp_c': data.soilTemp,
      'status_at_seeding': data.status,
      'germination_window_min': data.germinationMin,
      'germination_window_max': data.germinationMax
    }]);
  }

  /* ============================================================
     HELPERS
     ============================================================ */
  /* Safe localStorage wrappers (Safari private browsing throws on writes) */
  function safeStorageGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }
  function safeStorageSet(key, value) {
    try { localStorage.setItem(key, value); } catch (e) { /* silent */ }
  }

  function getBlendInfo(slug) {
    if (!CONFIG || !CONFIG.blends) return null;
    for (var i = 0; i < CONFIG.blends.length; i++) {
      if (CONFIG.blends[i].slug === slug) return CONFIG.blends[i];
    }
    return null;
  }

  function formatDate(dateStr) {
    var d = new Date(dateStr + 'T12:00:00');
    var months = LANG === 'en'
      ? ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      : ['janv.', 'fév.', 'mars', 'avr.', 'mai', 'juin', 'juill.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
    return d.getDate() + ' ' + months[d.getMonth()];
  }

  /* ============================================================
     BOOT
     ============================================================ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
